"use strict";
Object.defineProperties(exports, { __esModule: { value: true }, [Symbol.toStringTag]: { value: "Module" } });
const vue = require("vue");
const _hoisted_1$1e = {
  fill: "none",
  height: "96",
  viewBox: "0 0 96 96",
  width: "96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1e = /* @__PURE__ */ vue.createStaticVNode('<path d="M21.956 51.343c-1.613 2.3-4.071 3.769-6.826 3.769-4.857 0-8.794-4.568-8.794-10.202s3.937-10.2 8.794-10.2c3.979 0 7.34 3.064 8.425 7.27" stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.29"></path><path d="M29.964 33.017h52.752" stroke="gray" stroke-miterlimit="10" stroke-width="1.29"></path><path d="M56.776 41.975v-8.958l-4.487 8.948" stroke="gray" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.29"></path><path d="M12.604 44.911c0-1.619 1.131-2.936 2.526-2.936h54.568c8.002 0 11.798 4.195 14.103 9.858 2.306 5.664 3.644 9.033 4.747 11.798.995 2.493 1.356 7.866-6.917 7.866H51.48c-9.045 0-6.014-8.926-10.395-11.012-4.804-2.288-25.45-12.146-26.58-12.742-1.131-.596-1.9-1.213-1.9-2.832z" stroke="gray" stroke-miterlimit="10" stroke-width="1.29"></path><path d="M42.846 79.048h46.652" stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.29"></path><path d="M86.978 59.698H56.776l5.952-11.959h18.91m-12.796.001v11.958" stroke="gray" stroke-miterlimit="10" stroke-width="1.29"></path>', 6);
const _hoisted_8$5 = [
  _hoisted_2$1e
];
function render$1e(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$1e, _hoisted_8$5);
}
const HelicopterGraphic = { render: render$1e };
const _hoisted_1$1d = {
  fill: "none",
  height: "96",
  viewBox: "0 0 96 96",
  width: "96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1d = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m49.594 79.681-2.226-31.677-.26-4.543m-4.198-.091-3.129 36.31m2.349-40.971-5.965.514a5.364 5.364 0 0 0-4.164 2.634L21.476 60.083a2.75 2.75 0 0 0 1.754 4.057l.157.035L44.54 41.834m1.323-.179 3.427 4.91a5.37 5.37 0 0 0 4.365 2.289h21.046a2.749 2.749 0 0 0 2.637-3.546l-.05-.153-29.924-7.149m-.827-1.052 2.537-5.422a5.369 5.369 0 0 0-.198-4.925L38.352 8.379a2.75 2.75 0 0 0-4.389-.51l-.108.119 8.771 29.49",
  stroke: "gray",
  "stroke-miterlimit": "10",
  "stroke-width": "1.29"
}, null, -1);
const _hoisted_3$K = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M44.842 41.848a2.743 2.743 0 1 0-.001-5.485 2.743 2.743 0 0 0 .001 5.485zM18 79.64h56.68",
  stroke: "#FF000F",
  "stroke-miterlimit": "10",
  "stroke-width": "1.29"
}, null, -1);
const _hoisted_4$B = [
  _hoisted_2$1d,
  _hoisted_3$K
];
function render$1d(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$1d, _hoisted_4$B);
}
const FanGraphic = { render: render$1d };
const _hoisted_1$1c = {
  fill: "none",
  height: "96",
  viewBox: "0 0 96 96",
  width: "96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1c = /* @__PURE__ */ vue.createStaticVNode('<path d="M70.982 59.971c-5.882 5.883-14.01 9.522-22.986 9.522s-17.102-3.639-22.985-9.522c5.883 5.883 14.01 9.522 22.985 9.522 8.976 0 17.104-3.639 22.986-9.522zM47.996 15.764V11v4.764z" stroke="gray" stroke-miterlimit="10" stroke-width="1.29"></path><path d="M47.997 39.089a3.397 3.397 0 1 0 0-6.795 3.397 3.397 0 0 0 0 6.795z" stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.29"></path><path d="M51.212 26.015v-9.984h-6.431v9.984" stroke="gray" stroke-miterlimit="10" stroke-width="1.29"></path><path d="M47.996 45.885c5.63 0 10.194-4.564 10.194-10.194 0-5.63-4.564-10.193-10.194-10.193-5.63 0-10.193 4.564-10.193 10.193 0 5.63 4.564 10.194 10.194 10.194zM34.563 57.178l-12.27 21.257" stroke="gray" stroke-miterlimit="10" stroke-width="1.29"></path><path d="m39.499 41.324-8.13 13.979 6.667 3.877 7.857-13.514m15.536 11.512 12.269 21.257M56.492 41.324l8.13 13.979-6.666 3.877-7.86-13.514" stroke="gray" stroke-miterlimit="10" stroke-width="1.29"></path><path d="M14 78.44h67.992" stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.29"></path>', 6);
const _hoisted_8$4 = [
  _hoisted_2$1c
];
function render$1c(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$1c, _hoisted_8$4);
}
const CompassGraphic = { render: render$1c };
const _hoisted_1$1b = {
  fill: "none",
  height: "96",
  viewBox: "0 0 96 96",
  width: "96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1b = /* @__PURE__ */ vue.createStaticVNode('<path d="M2 79.651h92.077M43.655 26l-19.23 33.315" stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.29"></path><path d="M20.266 58.681 4.426 43.502 14.531 26h29.124l15.742 14.87M72.23 78.505c5.48 0 9.922-4.442 9.922-9.922s-4.442-9.922-9.922-9.922-9.922 4.442-9.922 9.922 4.442 9.922 9.922 9.922zm-41.434-9.922h31.509" stroke="gray" stroke-miterlimit="10" stroke-width="1.29"></path><path d="M72.229 71.891a3.308 3.308 0 1 0 0-6.616 3.308 3.308 0 0 0 0 6.616zm-51.356 6.614c5.48 0 9.922-4.442 9.922-9.922s-4.442-9.922-9.922-9.922-9.922 4.442-9.922 9.922 4.442 9.922 9.922 9.922z" stroke="gray" stroke-miterlimit="10" stroke-width="1.29"></path><path d="M20.874 71.89a3.307 3.307 0 1 0 0-6.614 3.307 3.307 0 0 0 0 6.614zm61.97-23.934h-25.43 25.43zm5.47 6.236v14.391h-6.162 6.162V54.192zm0 0c0-3.796-2.952-6.236-5.471-6.236l-2.2-17.448a4.69 4.69 0 0 0-4.652-4.103" stroke="gray" stroke-miterlimit="10" stroke-width="1.29"></path><path d="M53.508 61.591H27.94h25.567zm0 0L63.58 26.426l12.41-.021a4.69 4.69 0 0 1 4.653 4.104l2.198 17.448" stroke="gray" stroke-miterlimit="10" stroke-width="1.29"></path>', 5);
const _hoisted_7$7 = [
  _hoisted_2$1b
];
function render$1b(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$1b, _hoisted_7$7);
}
const TruckGraphic = { render: render$1b };
const _hoisted_1$1a = {
  fill: "none",
  height: "96",
  viewBox: "0 0 96 96",
  width: "96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1a = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M71.42 29.001 59.815 49.489",
  stroke: "#FF000F",
  "stroke-miterlimit": "10",
  "stroke-width": "1.29"
}, null, -1);
const _hoisted_3$J = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M35.737 49.49 24.13 29m53.94 20.49c0 12.661-17.671 29.804-21.036 29.804H38.52c-3.367 0-21.281-16.95-21.037-29.805H78.07z",
  stroke: "gray",
  "stroke-miterlimit": "10",
  "stroke-width": "1.29"
}, null, -1);
const _hoisted_4$A = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M17 79.321h61.552",
  stroke: "#FF000F",
  "stroke-miterlimit": "10",
  "stroke-width": "1.29"
}, null, -1);
const _hoisted_5$k = [
  _hoisted_2$1a,
  _hoisted_3$J,
  _hoisted_4$A
];
function render$1a(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$1a, _hoisted_5$k);
}
const BowlGraphic = { render: render$1a };
const _hoisted_1$19 = {
  fill: "none",
  height: "96",
  viewBox: "0 0 96 96",
  width: "96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$19 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m69.984 49.573-19.218-9.229v9.229l-19.214-9.229v9.229l-19.218-9.229v39.148",
  stroke: "gray",
  "stroke-miterlimit": "10",
  "stroke-width": "1.29"
}, null, -1);
const _hoisted_3$I = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M84.1 39.146 68.815 65.621",
  stroke: "#FF000F",
  "stroke-miterlimit": "10",
  "stroke-width": "1.29"
}, null, -1);
const _hoisted_4$z = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m87.172 79.493-4.437-58.267H72.194l-4.435 58.267m14.628-58.266L70.647 41.56m14.765 14.813L72.01 79.59",
  stroke: "gray",
  "stroke-miterlimit": "10",
  "stroke-width": "1.29"
}, null, -1);
const _hoisted_5$j = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M3.715 79.589h92.076",
  stroke: "#FF000F",
  "stroke-miterlimit": "10",
  "stroke-width": "1.29"
}, null, -1);
const _hoisted_6$9 = [
  _hoisted_2$19,
  _hoisted_3$I,
  _hoisted_4$z,
  _hoisted_5$j
];
function render$19(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$19, _hoisted_6$9);
}
const BuildingGraphic = { render: render$19 };
const _hoisted_1$18 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "96",
  height: "96",
  fill: "none",
  viewBox: "0 0 96 96"
};
const _hoisted_2$18 = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "#FF000F",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "m39.826 37.002-20.69 35.836m12.231-35.836L10.68 72.838"
}, null, -1);
const _hoisted_3$H = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "gray",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M9 37h40.158c1.894 0 3.732.649 5.206 1.838l24.087 19.43a8.192 8.192 0 0 1-5.143 14.57H9"
}, null, -1);
const _hoisted_4$y = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "gray",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M74.586 54.994H55.182l-7.136-6.163c-2.014-1.74-.784-5.046 1.877-5.046H60.64m2.02 29.201a4.38 4.38 0 0 1-8.76 0m-1.232 0a4.38 4.38 0 1 1-8.76 0m-1.231 0a4.38 4.38 0 0 1-8.76 0"
}, null, -1);
const _hoisted_5$i = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "#FF000F",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M9 78.558h78.9"
}, null, -1);
const _hoisted_6$8 = [
  _hoisted_2$18,
  _hoisted_3$H,
  _hoisted_4$y,
  _hoisted_5$i
];
function render$18(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$18, _hoisted_6$8);
}
const TrainGraphic = { render: render$18 };
const _hoisted_1$17 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "96",
  height: "96",
  fill: "none",
  viewBox: "0 0 96 96"
};
const _hoisted_2$17 = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "#FF000F",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M22.841 49.986h7.8l2.986-5.173 1.946 3.372 4.959-8.59 9.237 16.002 6.665-11.545 3.426 5.934 2.08-3.604 2.08 3.604h8.737"
}, null, -1);
const _hoisted_3$G = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "gray",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M70.295 53.12c4.772-4.491 6.084-11.883 2.646-17.802-4.051-6.986-12.9-9.382-19.874-5.38a14.51 14.51 0 0 0-2.947 2.23L47.8 34.49l-2.32-2.324a14.555 14.555 0 0 0-2.947-2.23c-6.973-4.002-15.823-1.606-19.873 5.38-3.438 5.92-2.127 13.31 2.644 17.803L47.8 75.557 70.295 53.12z"
}, null, -1);
const _hoisted_4$x = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "#FF000F",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M19 79.386h57.6"
}, null, -1);
const _hoisted_5$h = [
  _hoisted_2$17,
  _hoisted_3$G,
  _hoisted_4$x
];
function render$17(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$17, _hoisted_5$h);
}
const HeartGraphic = { render: render$17 };
const _hoisted_1$16 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "96",
  height: "96",
  fill: "none",
  viewBox: "0 0 96 96"
};
const _hoisted_2$16 = /* @__PURE__ */ vue.createStaticVNode('<path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M81.75 29.41H69.222v11.253H81.75V29.41zM23.878 60.234l-5.788-9.566m0 0V29.734v20.934zm0 0-5.787 9.566m47.582 18.383V34.356v44.26zM48.477 14.985v14.424-14.676L54.18 12l5.704 2.648v14.77"></path><path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M69.222 29.41H18.09v4.947h51.132M17.75 29.35 54.18 12m5.705 2.649-11.41 19.763"></path><path stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.5" d="M23.794 60.522H12.385V65.6h11.409v-5.078zM59.885 29.42l-11.41 19.762"></path><path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="m59.885 44.192-11.41 19.762m11.41-4.991-11.41 19.762m.002-.108V34.412v44.205zM62.12 29.41h-5.726"></path><path stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.5" d="M5 78.414h85.653"></path>', 5);
const _hoisted_7$6 = [
  _hoisted_2$16
];
function render$16(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$16, _hoisted_7$6);
}
const CraneGraphic = { render: render$16 };
const _hoisted_1$15 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "96",
  height: "96",
  fill: "none",
  viewBox: "0 0 96 96"
};
const _hoisted_2$15 = /* @__PURE__ */ vue.createStaticVNode('<path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="m76.166 78.937-3.347-5.8H23.75l-3.35 5.8m10.962-45.245 27.468 6.894"></path><path stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.5" d="M72.195 39.187 65.64 57.569"></path><path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M32.449 24.01a4.943 4.943 0 0 1 4.725 7.144 4.947 4.947 0 0 1-8.55.52 4.945 4.945 0 0 1 3.825-7.665zm35.478 7.322L33.51 24.06m17.66 31.383v17.695M27.482 55.466l-3.684-1.939v-9.596l8.95-4.535 8.952 4.535v9.596l-3.803 1.939"></path><path stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.5" d="M37.896 49.078H27.601v10.296h10.295V49.078z"></path><path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M32.749 39.396v-5.514m33.118 21.913v17.343"></path><path stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.5" d="M62.456 34.269 52.149 52.121"></path><path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M66.983 31.305a5.455 5.455 0 1 1 .662 10.89 5.455 5.455 0 0 1-.662-10.89zm-8.472 17.143a7.347 7.347 0 1 1 0 14.693 7.347 7.347 0 0 1 0-14.693z"></path><path stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.5" d="M14 78.937h68.566"></path>', 8);
const _hoisted_10$1 = [
  _hoisted_2$15
];
function render$15(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$15, _hoisted_10$1);
}
const ArmGraphic = { render: render$15 };
const _hoisted_1$14 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "96",
  height: "96",
  fill: "none",
  viewBox: "0 0 96 96"
};
const _hoisted_2$14 = /* @__PURE__ */ vue.createStaticVNode('<path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M71.326 43.028h-.706l.006.003c.256 0 .492-.003.7-.003zm14.121 28.247h4.307s1.133.121 1.133-1.105l.019-8.965c0-1.058-.619-1.883-1.806-2.249-1.187-.365-8.858-2.9-8.858-2.9-2.856-4.312-7.416-12.913-9.616-13.025M32.797 71.275h39.04"></path><path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M58.512 43.028h12.109c-.015 0-.031-.008-.047-.008h-.128c1.676-.05 2.937-1.487 2.499-3.117C72.568 38.518 67.462 31 67.462 31l-61.413.042v37.74l7.55 2.492h5.603"></path><path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M74.947 47.828h-14.76v8.346h20.055M32.817 71.049a6.813 6.813 0 0 1-6.812 6.811 6.812 6.812 0 0 1-6.809-6.811c0-3.76 3.051-6.81 6.809-6.81a6.814 6.814 0 0 1 6.812 6.81zm52.636 0a6.812 6.812 0 0 1-13.622 0 6.811 6.811 0 0 1 13.622 0z"></path><path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M54.076 71.557V45.95s-.491-2.923 2.76-2.923h12.418"></path><path stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.5" d="M37.84 54.692H14.241l9.268-16.054h23.594l-9.265 16.054z"></path><path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M78.641 74.124a3.075 3.075 0 1 0-.003-6.15 3.075 3.075 0 0 0 .004 6.15zm-52.635 0a3.075 3.075 0 1 0 0-6.15 3.075 3.075 0 0 0 0 6.15z"></path><path stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.5" d="M3 79.051h90.955"></path><path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M65.656 47.828v8.346"></path>', 8);
const _hoisted_10 = [
  _hoisted_2$14
];
function render$14(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$14, _hoisted_10);
}
const VanGraphic = { render: render$14 };
const _hoisted_1$13 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "96",
  height: "96",
  fill: "none",
  viewBox: "0 0 96 96"
};
const _hoisted_2$13 = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "gray",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M37.064 79.112V69.76m7.48 9.352V69.76m7.48 9.352V69.76m7.48 9.352V69.76m-22.44-37.408V23m7.48 9.352V23m7.48 9.352V23m7.48 9.352V23m7.48 9.352H29.576V69.76h37.408V32.352z"
}, null, -1);
const _hoisted_3$F = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "gray",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M59.48 61.36H37.064v-4.816l9.504-16.712H59.48V61.36zM20.224 39.832h9.352m-9.352 7.48h9.352M20.224 54.8h9.352m-9.352 7.48h9.352m37.408-22.448h9.352m-9.352 7.48h9.352M66.984 54.8h9.352m-9.352 7.48h9.352"
}, null, -1);
const _hoisted_4$w = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "#FF000F",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M37.064 39.832h4.704l-4.704 7.912v-7.912zM14 79.184h68.568"
}, null, -1);
const _hoisted_5$g = [
  _hoisted_2$13,
  _hoisted_3$F,
  _hoisted_4$w
];
function render$13(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$13, _hoisted_5$g);
}
const ChipGraphic = { render: render$13 };
const _hoisted_1$12 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "96",
  height: "96",
  fill: "none",
  viewBox: "0 0 96 96"
};
const _hoisted_2$12 = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "gray",
  "stroke-linejoin": "bevel",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M64.91 48.802c4.619-7.515 3.723-17.582-2.827-24.062-7.722-7.653-20.063-7.653-27.716 0-6.55 6.55-7.514 16.684-2.757 24.2l16.616 28.75L64.91 48.802z"
}, null, -1);
const _hoisted_3$E = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "#FF000F",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M48.226 45.078a6.48 6.48 0 0 0 6.48-6.48 6.48 6.48 0 1 0-6.481 6.48zM26 77.69h44.435"
}, null, -1);
const _hoisted_4$v = [
  _hoisted_2$12,
  _hoisted_3$E
];
function render$12(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$12, _hoisted_4$v);
}
const PinGraphic = { render: render$12 };
const _hoisted_1$11 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "96",
  height: "96",
  fill: "none",
  viewBox: "0 0 96 96"
};
const _hoisted_2$11 = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "gray",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M16 77.717V61.658h9.985v16.059m7.819 0V51.394h9.984v26.323m7.682 0V61.658h9.983v16.059m7.751 0V41.55h9.984v36.167"
}, null, -1);
const _hoisted_3$D = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "#FF000F",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M58.102 49.789 74.162 22"
}, null, -1);
const _hoisted_4$u = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "gray",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "m41.345 41.34 12.567 9.356m-30.302 0 12.568-9.355m-15.15 14.452a3.212 3.212 0 1 0 0-6.424 3.212 3.212 0 0 0 0 6.424zm17.734-13.195a3.213 3.213 0 1 0-.001-6.425 3.213 3.213 0 0 0 .001 6.425zm17.734 13.195a3.212 3.212 0 1 0 0-6.424 3.212 3.212 0 0 0 0 6.424z"
}, null, -1);
const _hoisted_5$f = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "#FF000F",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M69.133 23.326 74.162 22l1.396 5.027M8 77.717h79.189"
}, null, -1);
const _hoisted_6$7 = [
  _hoisted_2$11,
  _hoisted_3$D,
  _hoisted_4$u,
  _hoisted_5$f
];
function render$11(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$11, _hoisted_6$7);
}
const GraphGraphic = { render: render$11 };
const _hoisted_1$10 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "96",
  height: "96",
  fill: "none",
  viewBox: "0 0 96 96"
};
const _hoisted_2$10 = /* @__PURE__ */ vue.createStaticVNode('<path stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.5" d="M39.355 32.998a6.5 6.5 0 1 0-.001-13 6.5 6.5 0 0 0 .002 13z"></path><path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M39.355 66.613V79.54m11.671-20.125c2.725-.769 4.403-3.564 3.634-6.36L51.027 39.43c-.63-2.237-2.656-3.844-5.032-3.844h-.14l-2.377 4.122h-8.175l-2.377-4.122h-.21c-2.306 0-4.402 1.537-4.96 3.844L24.05 53.056c-.699 2.795.91 5.59 3.634 6.36"></path><path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M45.855 79.54V66.614h7.128l-6.219-23.271m-14.815-.001-6.22 23.27h7.128v12.929M66.54 60.114a5.16 5.16 0 0 0 5.172-5.172V39.43a4.573 4.573 0 0 0-3.145-4.333l-3.354-.84-2.167 3.774h-6.01l-2.166-3.773"></path><path stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.5" d="M60.042 31.67a5.8 5.8 0 1 0 0-11.6 5.8 5.8 0 0 0 0 11.6z"></path><path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M53.612 79.54v-7.757M66.54 42.014V79.54m-6.498-22.013v22.014"></path><path stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.5" d="M19 79.797h57.6"></path>', 6);
const _hoisted_8$3 = [
  _hoisted_2$10
];
function render$10(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$10, _hoisted_8$3);
}
const PeopleGraphic = { render: render$10 };
const _hoisted_1$$ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "96",
  height: "96",
  fill: "none",
  viewBox: "0 0 96 96"
};
const _hoisted_2$$ = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "#FF000F",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M19 78.522h57.6"
}, null, -1);
const _hoisted_3$C = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "gray",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "m67.194 61.596-38.79-22.4m15.863-10.913a19.647 19.647 0 0 0 9.245 12.22 19.654 19.654 0 0 0 15.205 1.899M51.29 72.515a19.65 19.65 0 0 0-9.233-12.174 19.653 19.653 0 0 0-15.16-1.912"
}, null, -1);
const _hoisted_4$t = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "#FF000F",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "m59 31.002-22.4 38.79"
}, null, -1);
const _hoisted_5$e = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "gray",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M47.8 72.792c12.369 0 22.396-10.027 22.396-22.396C70.196 38.027 60.169 28 47.8 28c-12.37 0-22.396 10.027-22.396 22.396 0 12.369 10.027 22.396 22.396 22.396z"
}, null, -1);
const _hoisted_6$6 = [
  _hoisted_2$$,
  _hoisted_3$C,
  _hoisted_4$t,
  _hoisted_5$e
];
function render$$(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$$, _hoisted_6$6);
}
const BallGraphic = { render: render$$ };
const _hoisted_1$_ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "96",
  height: "96",
  fill: "none",
  viewBox: "0 0 96 96"
};
const _hoisted_2$_ = /* @__PURE__ */ vue.createStaticVNode('<path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M70.356 72.854a3.074 3.074 0 1 0 0-6.147 3.074 3.074 0 0 0 0 6.147z"></path><path stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.5" d="m35.998 34.004-8.916 15.445"></path><path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M18.531 69.78h-.818c-4.763 0-4.37-3.75-4.253-10.265.01-.535.004-6.665.001-9.21 0-.72.19-1.423.556-2.043l7.67-13.036A2.483 2.483 0 0 1 23.829 34h23.508c3.462 0 9.104 2.694 14.49 6.669 5.387 3.976 10.003 8.208 13.722 10.644 3.72 2.437 7.823 4.104 7.823 9.875v5.13c0 2.05-1.667 3.462-5.515 3.462m-14.755 0H33.624"></path><path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M70.356 77.034a7.254 7.254 0 1 0 0-14.508 7.254 7.254 0 1 0 0 14.508zm-44.118-4.179a3.076 3.076 0 1 0 0-6.151 3.076 3.076 0 0 0 0 6.151z"></path><path stroke="gray" stroke-miterlimit="10" stroke-width="1.5" d="M26.24 77.034a7.254 7.254 0 1 0 .001-14.509 7.254 7.254 0 0 0-.002 14.509zm46.703-27.585H13.578m22.887 0V34.004"></path><path stroke="#FF000F" stroke-miterlimit="10" stroke-width="1.5" d="M7 78.229h82.772"></path>', 6);
const _hoisted_8$2 = [
  _hoisted_2$_
];
function render$_(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$_, _hoisted_8$2);
}
const CarGraphic = { render: render$_ };
const _hoisted_1$Z = {
  width: "96",
  height: "96",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 96 96"
};
const _hoisted_2$Z = /* @__PURE__ */ vue.createStaticVNode('<g stroke-miterlimit="10" stroke-width="1.5"><path d="M12 84.055h72" fill="#1d1d1b" stroke="#ff000f"></path><path d="M12.51 84.055h71" fill="none" stroke="#ff000f"></path><path d="M25.85 63.905a28.23 28.23 0 0 1 17.56-45.57m25.04 8.6.57.63a28.22 28.22 0 0 1-29.87 45.5" fill="none" stroke="gray"></path></g><path d="m51.05 15.435 1 1.33 16.74-3.42-11.45 19.13h7.83l-34.72 35.88-5 5.62h1.62l41.6-43H60l11.76-19.78L53 15.035Z" fill="gray"></path><path d="M38.44 40.285h8.17l-16.16 28.07-3.33 5.61H25.5l18.52-32.17h-8.17l15.2-26.36 1.95-.4z" fill="#ff000f"></path>', 3);
const _hoisted_5$d = [
  _hoisted_2$Z
];
function render$Z(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$Z, _hoisted_5$d);
}
const InnovationGraphic = { render: render$Z };
const _hoisted_1$Y = {
  width: "96",
  height: "96",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 96 96"
};
const _hoisted_2$Y = /* @__PURE__ */ vue.createStaticVNode('<g fill="none" stroke-width="1.5"><g stroke="gray"><path d="m47.63 37.094 1.34 5.68 8.78-.41m-19.81-.18 5 11.13L56 51.824m-23.75-24.24h-6.81v-6.72m38.41 40.69 6.71-.21.21 6.72" stroke-linejoin="round"></path><path d="M21.92 33.874a28.13 28.13 0 0 0 48.23 27.89m3.93-6.72a28.13 28.13 0 0 0-48.23-27.88" stroke-linejoin="round"></path><path d="M58.18 26.834 34 68.704" stroke-miterlimit="10"></path></g><path d="M12 79.624h72m-40.5-40.46c-7.67 3.06-14.58 9.71-10 17.66 4.25 7.41 16.22 6.57 21.07-1.55 4.43-7.36 3.53-29.43 3.53-29.43s-7.31 10.41-14.6 13.32z" stroke="#ff000f" stroke-miterlimit="10"></path><path d="M42.94 53.314 34 68.704" stroke="gray" stroke-miterlimit="10"></path></g>', 1);
const _hoisted_3$B = [
  _hoisted_2$Y
];
function render$Y(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$Y, _hoisted_3$B);
}
const SustainabilityGraphic = { render: render$Y };
const _hoisted_1$X = {
  width: "96",
  height: "96",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 96 96"
};
const _hoisted_2$X = /* @__PURE__ */ vue.createStaticVNode('<g fill="none" stroke-miterlimit="10" stroke-width="1.5"><path d="M12 81.667h72" stroke="#ff000f"></path><g stroke-linecap="square" transform="translate(-22 -21.013)"><circle cx="69.94" cy="65.18" r="12.44" stroke="#ff000f"></circle><path d="m69.94 90.66-6.41-3.71-4.49 7.79-9.24-5.34 4.49-7.78-6.41-3.7v-7.4h-8.99V59.84h8.99v-7.4l6.41-3.7-4.49-7.78 9.24-5.34 4.49 7.78 6.41-3.7 6.41 3.7 4.49-7.78 9.25 5.34-4.5 7.78 6.41 3.7v7.4h8.99v10.68H92v7.4l-6.41 3.7 4.5 7.78-9.25 5.34-4.49-7.79z" stroke="gray"></path></g></g>', 1);
const _hoisted_3$A = [
  _hoisted_2$X
];
function render$X(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$X, _hoisted_3$A);
}
const ServicesGraphic = { render: render$X };
const _hoisted_1$W = {
  width: "96",
  height: "96",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 96 96"
};
const _hoisted_2$W = /* @__PURE__ */ vue.createStaticVNode('<g stroke-width="1.5"><path d="M12 80.684h72" fill="#1d1d1b" stroke="#ff000f" stroke-miterlimit="10"></path><g fill="none" stroke-linejoin="round"><path d="M32.25 26.514h-6.81v-6.71" stroke="#ff000f"></path><path d="m63.85 60.494 6.71-.21.21 6.71" stroke="gray"></path><path d="M21.92 32.814a28.13 28.13 0 0 0 48.23 27.91" stroke="gray"></path><path d="M74.08 53.984a28.13 28.13 0 0 0-48.23-27.88" stroke="#ff000f"></path></g></g>', 1);
const _hoisted_3$z = [
  _hoisted_2$W
];
function render$W(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$W, _hoisted_3$z);
}
const ReuseGraphic = { render: render$W };
const _hoisted_1$V = {
  width: "96",
  height: "96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 96 96"
};
const _hoisted_2$V = /* @__PURE__ */ vue.createStaticVNode('<g stroke-width="1.5"><path d="M12 82.565h72" stroke="#ff000f" stroke-miterlimit="10"></path><g stroke-linejoin="round"><path d="m74.28 32.375 7.77 14.49-13.56 21.31H57.93v8.59l-7.96-15.93 7.96-15.42v8.59h10.46l-7.76-14.28Zm-5.89 21.63h9.13" stroke="gray"></path><path d="m27.3 27.765 8.06-14.33h25.27l5.66 8.91 7.25-4.61-9.18 15.27-17.28 1.55 7.25-4.6-5.61-8.82-7.89 14.21zm21.42-6.63-4.9-7.71" stroke="#ff000f"></path><path d="m45.03 69.895-16.44-.03-12.35-22.04 5-9.29-7.56-4.07 17.81.53 9.8 14.32-7.56-4.07-4.95 9.21 16.25-.07zm-16.25-15.44-4.33 8.04" stroke="gray"></path></g></g>', 1);
const _hoisted_3$y = [
  _hoisted_2$V
];
function render$V(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$V, _hoisted_3$y);
}
const RecycleGraphic = { render: render$V };
const _hoisted_1$U = {
  width: "96",
  height: "96",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 96 96"
};
const _hoisted_2$U = /* @__PURE__ */ vue.createElementVNode("g", {
  fill: "none",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5"
}, [
  /* @__PURE__ */ vue.createElementVNode("path", {
    d: "M7.47 81.8h81.06",
    stroke: "#ff000f"
  }),
  /* @__PURE__ */ vue.createElementVNode("path", {
    d: "M45.57 16.25 37.9 29.51h7.67zM12.78 72.94h32.79V62.3H18.93Zm8.47-14.64h24.32V46.46H28.1Zm14.34-24.79-5.18 8.95h15.16v-8.95zm14.84-17.26 7.67 13.26h-7.67Zm32.79 56.69H50.43V62.3h26.64zM74.75 58.3H50.43V46.46H67.9ZM60.42 33.51l5.17 8.95H50.43v-8.95z",
    stroke: "gray"
  })
], -1);
const _hoisted_3$x = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m39.2 28.76 5.62-9.72v.01l1.5-2.6v-3L36.6 30.26h1.74zM14.08 72.19l5.29-9.13.87-1.5H18.5l-7.02 12.13h1.74l.87-1.5zm8.47-14.64 5.98-10.34.87-1.5h-1.74l-7.71 13.34h1.74zm9.16-15.84 4.31-7.45.87-1.5h-1.74l-6.04 10.45h1.74z",
  fill: "#ff000f"
}, null, -1);
const _hoisted_4$s = [
  _hoisted_2$U,
  _hoisted_3$x
];
function render$U(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$U, _hoisted_4$s);
}
const ProductsGraphic = { render: render$U };
const _hoisted_1$T = {
  width: "96",
  height: "96",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 96 96"
};
const _hoisted_2$T = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M13 75.115h70",
  fill: "none",
  stroke: "#ff000f",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5"
}, null, -1);
const _hoisted_3$w = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M48.2 68.385h-1.77l-22-38.15h14.8v-10.1h16.19v10.1h14.8zm-.9-1.5 20.3-35.15H53.92v-10.1H40.78v10.1H27.07Z",
  fill: "gray"
}, null, -1);
const _hoisted_4$r = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M46.43 68.385h1.77l22.02-38.15h-1.76Z",
  fill: "#ff000f"
}, null, -1);
const _hoisted_5$c = [
  _hoisted_2$T,
  _hoisted_3$w,
  _hoisted_4$r
];
function render$T(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$T, _hoisted_5$c);
}
const ReduceGraphic = { render: render$T };
const _hoisted_1$S = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$S = /* @__PURE__ */ vue.createStaticVNode('<g clip-path="url(#a)" stroke-width="1.5" stroke-miterlimit="10"><path d="M47.95 71.25C63 71.25 75.2 59.05 75.2 44S63 16.75 47.95 16.75 20.7 28.95 20.7 44s12.2 27.25 27.25 27.25z" stroke="gray"></path><path d="M34.33 67.61 61.57 20.4" stroke="#FF000F"></path><path d="m24.35 30.38 47.2 27.25m-9.76-5.659c7.523-13.035 7.44-27.169-.184-31.57-7.625-4.4-19.905 2.6-27.427 15.635-7.523 13.035-7.44 27.169.185 31.569 7.625 4.4 19.904-2.6 27.426-15.634z" stroke="gray"></path><path d="M74.29 36.9a37.08 37.08 0 0 1-33.4-19.18m14.07 52.66c-2.58-5.37-7.47-10.59-14-14.37a34.85 34.85 0 0 0-19.3-5" stroke="gray"></path><path d="M10 78.73h75.9" stroke="#FF000F"></path></g><defs><clipPath id="a"><path fill="#fff" transform="translate(10 16)" d="M0 0h75.9v63.48H0z"></path></clipPath></defs>', 2);
const _hoisted_4$q = [
  _hoisted_2$S
];
function render$S(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$S, _hoisted_4$q);
}
const ExpertiseCollaborationGraphic = { render: render$S };
const _hoisted_1$R = {
  width: "96",
  height: "96",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 96 96"
};
const _hoisted_2$R = /* @__PURE__ */ vue.createStaticVNode('<clipPath id="a"><path d="m59.73 56.88-8.09 14a8.73 8.73 0 0 0-1.15 5.66 12.32 12.32 0 0 0 9.1 10.21A12.49 12.49 0 0 0 68.87 77a8.79 8.79 0 0 0-1.08-6.11z"></path></clipPath><g clip-path="url(#a)" fill="none" stroke="#ff000f" stroke-miterlimit="10" stroke-width="1.5" transform="translate(-22 -19.014)"><path d="M62.58 60.65 51.47 79.88m13.84-14.94L54.34 83.93m13.67-14.64-9.85 17.05"></path></g><path d="M78.67 48.556 63.5 74.836H16.51" fill="none" stroke="gray" stroke-miterlimit="10" stroke-width="1.5"></path><path d="m70.87 49.796.44 1.43 7.07-2.17 1.65 7.21 1.47-.34-2.02-8.78z" fill="gray"></path><g fill="none" stroke-miterlimit="10" stroke-width="1.5"><path d="m39.72 34.426-10.08 17.46a8.73 8.73 0 0 0-1.15 5.66c.9 5.8 5.62 10.18 10.64 10.42 5.24.25 10.53-4 11.71-10a8.84 8.84 0 0 0-1.08-6.11q-5.03-8.73-10.04-17.43Zm11.07-19.14-6.31 10.92a5.49 5.49 0 0 0-.71 3.54 7.52 7.52 0 0 0 6.65 6.51c3.28.16 6.59-2.52 7.32-6.27a5.55 5.55 0 0 0-.67-3.82q-3.15-5.43-6.28-10.88Zm10.89 18.57L58 40.306a3.26 3.26 0 0 0-.42 2.09 4.14 4.14 0 0 0 8.25.14 3.23 3.23 0 0 0-.4-2.25c-1.28-2.15-2.52-4.3-3.75-6.43Z" stroke="gray"></path><path d="M10.67 81.466h74.66" stroke="#ff000f"></path></g>', 5);
const _hoisted_7$5 = [
  _hoisted_2$R
];
function render$R(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$R, _hoisted_7$5);
}
const FluidGraphic = { render: render$R };
const _hoisted_1$Q = {
  width: "96",
  height: "96",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 96 96"
};
const _hoisted_2$Q = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m69.68 44.625-.86-12.73-10.51-6-10.61 5.17-10.62-6.13-11.36 6.56v13.13l5.85 2.42 4.76 3.71.7 5.73-.7 5.66-4.14 3.48-6.47 2.66v12.69h1.5v-11.84l5-3.53 4.89-2.17 9.89 5.7v11.82h1.5v-11.82l9.86-5.7 9.87 5.7v11.82h1.5v-12.69l-10.67-6.13v-11.39zm-22 23.22-9.87-5.7-.81-5.67.8-5.73 9.87-5.69 9.86 5.69v11.39zm21.14-35.96-.64 11.87-9.87 5.69-9.86-5.69v-11.39l9.88-6.5zm-41.6.48 9.86-5.74 9.92 5.74v11.39l-9.87 5.69-5.51-2.41-4.35-3.28z",
  fill: "gray"
}, null, -1);
const _hoisted_3$v = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m68.93 32.795-11.37-6.56v-12.69h1.5v11.82l9.87 5.7 10.24-5.92.75 1.3z",
  fill: "#ff000f"
}, null, -1);
const _hoisted_4$p = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M13 81.705h70",
  fill: "none",
  stroke: "#ff000f",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5"
}, null, -1);
const _hoisted_5$b = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m26.47 69.565-11.37-6.56v-13.12l11.37-6.57 11.36 6.57v13.12zm-9.87-7.43 9.87 5.7 9.86-5.7v-11.39l-9.86-5.69-9.87 5.69zm53.08-17.52-1.5-.86v-11.39l-9.87-5.7-9.86 5.7-.75-.54v-.76l10.61-6.13 11.37 6.56z",
  fill: "#ff000f"
}, null, -1);
const _hoisted_6$5 = [
  _hoisted_2$Q,
  _hoisted_3$v,
  _hoisted_4$p,
  _hoisted_5$b
];
function render$Q(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$Q, _hoisted_6$5);
}
const AdvancedGraphic = { render: render$Q };
const _hoisted_1$P = {
  width: "96",
  height: "96",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 96 96"
};
const _hoisted_2$P = /* @__PURE__ */ vue.createStaticVNode('<g fill="none" stroke-miterlimit="10" stroke-width="1.5" transform="translate(-22 -22.003)"><path d="M31 105h78M69.3 62.64v15.45m4.62-4.58-4.61 4.58-4.66-4.56m4.65-10.89 13.39-7.72m-6.27-1.71 6.27 1.7-1.63 6.32M69.3 62.64l-13.38-7.72m1.66 6.28-1.66-6.29 6.29-1.74" stroke="#ff000f"></path><path d="M76.94 89.2A27.67 27.67 0 0 0 96.13 56m-53.65 0a27.67 27.67 0 0 0 19.19 33.2m26.81-46.45a27.6 27.6 0 0 0-38.35 0" stroke="gray"></path><circle cx="69.3" cy="90.29" r="7.72" stroke="gray"></circle><circle cx="93.25" cy="48.82" r="7.72" stroke="gray"></circle><circle cx="45.36" cy="48.82" r="7.72" stroke="gray"></circle></g>', 1);
const _hoisted_3$u = [
  _hoisted_2$P
];
function render$P(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$P, _hoisted_3$u);
}
const CollaborativeGraphic = { render: render$P };
const _hoisted_1$O = {
  width: "96",
  height: "96",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 96 96"
};
const _hoisted_2$O = /* @__PURE__ */ vue.createStaticVNode('<path d="M12 80.51h72" fill="none" stroke="#ff000f" stroke-miterlimit="10" stroke-width="1.5"></path><path d="M41.58 53.6 48 49.9l6.35 3.66.75-1.3-6.35-3.66v-6.73h-1.5v6.73l-6.42 3.7z" fill="#ff000f"></path><g fill="none" stroke-miterlimit="10" stroke-width="1.5" transform="translate(-22 -20.94)"><circle cx="88.94" cy="75.08" r="3.84" stroke="#ff000f"></circle><path d="M96.2 89.68v-5a3 3 0 0 0-3-3h-8.55a3 3 0 0 0-3 3v5" stroke="gray"></path><circle cx="88.94" cy="78.93" r="13.15" stroke="gray"></circle><circle cx="51.06" cy="75.08" r="3.84" stroke="#ff000f"></circle><path d="M58.31 89.68v-5a3 3 0 0 0-3-3h-8.55a3 3 0 0 0-3 3v5" stroke="gray"></path><circle cx="51.06" cy="78.93" r="13.15" stroke="gray"></circle><circle cx="70" cy="45.74" r="3.84" stroke="#ff000f"></circle><path d="M77.25 60.33v-5a3 3 0 0 0-3-3H65.7a3 3 0 0 0-3 3v5" stroke="gray"></path><circle cx="70" cy="49.58" r="13.15" stroke="gray"></circle></g>', 3);
const _hoisted_5$a = [
  _hoisted_2$O
];
function render$O(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$O, _hoisted_5$a);
}
const DesignGraphic = { render: render$O };
const _hoisted_1$N = {
  width: "96",
  height: "96",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 96 96"
};
const _hoisted_2$N = /* @__PURE__ */ vue.createStaticVNode('<path d="M9 79.2h78" fill="none" stroke="#ff000f" stroke-miterlimit="10" stroke-width="1.5"></path><path d="M47.62 49.07 19 32.56l28.6-16.51 28.63 16.51ZM22 32.56l25.6 14.78 25.63-14.78-25.61-14.78Z" fill="gray"></path><path d="m67.97 37.32 5.26 3.04-25.61 14.78-25.6-14.78 5.25-3.04-1.5-.86-6.75 3.9 28.6 16.51 28.61-16.51-6.76-3.9z" fill="#ff000f"></path><g fill="gray"><path d="m67.97 45.12 5.26 3.04-25.61 14.78-25.6-14.78 5.25-3.04-1.5-.86-6.75 3.9 28.6 16.51 28.61-16.51-6.76-3.9Z"></path><path d="m67.97 52.92 5.26 3.03-25.61 14.79-25.6-14.79 5.25-3.03-1.5-.86-6.75 3.89 28.6 16.52 28.61-16.52-6.76-3.89z"></path></g>', 4);
const _hoisted_6$4 = [
  _hoisted_2$N
];
function render$N(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$N, _hoisted_6$4);
}
const HighPerformanceGraphic = { render: render$N };
const _hoisted_1$M = {
  width: "96",
  height: "96",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 96 96"
};
const _hoisted_2$M = /* @__PURE__ */ vue.createStaticVNode('<g fill="none" stroke-miterlimit="10" stroke-width="1.5" transform="translate(-22 -22.45)"><path d="M31 101.21h78m-78 0h78" stroke="#ff000f"></path><path d="M66.84 77.5 46.5 84.87" stroke="gray"></path><path d="M81.42 51.62 77.13 59h-13.3l-4.45-7.38M67.42 59l1.49 7.69h2.99L73.39 59" stroke="#ff000f"></path><path d="m73.97 77.5 20.33 7.37" stroke="gray"></path><ellipse cx="70.4" cy="76.25" rx="3.79" ry="3.82" stroke="#ff000f"></ellipse><g stroke="gray"><path d="M80.99 39.69h4.86v4.92h-4.86z"></path><path d="M59.81 39.69v11.93l-13.92 5.36v27.9l24.51 8.81 24.52-8.81v-27.9l-13.93-5.36V39.69Z"></path><path d="M59.81 44.61h-4.86v-4.92h4.86z"></path></g></g>', 1);
const _hoisted_3$t = [
  _hoisted_2$M
];
function render$M(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$M, _hoisted_3$t);
}
const RapidGraphic = { render: render$M };
const _hoisted_1$L = {
  width: "96",
  height: "96",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 96 96"
};
const _hoisted_2$L = /* @__PURE__ */ vue.createStaticVNode('<g fill="none" stroke-miterlimit="10" stroke-width="1.5" transform="translate(-22 -20.26)"><path d="M34 101.41h72" stroke="#ff000f"></path><g stroke="gray"><path d="m87.56 86.37 4.73-3.72"></path><circle cx="95.61" cy="54.22" r="4"></circle><circle cx="95.61" cy="80.05" r="4"></circle><path d="M95.61 76.05V58.22m-3.44-6.03L73.45 41.14M52.44 86.37l-4.73-3.72"></path><circle cx="70" cy="39.11" r="4"></circle></g><circle cx="70" cy="66.75" r="9.66" stroke="#ff000f"></circle><path d="M88.25 101.41V88.8a7.44 7.44 0 0 0-7.44-7.44H59.19a7.44 7.44 0 0 0-7.44 7.44v12.61" stroke="#ff000f"></path><circle cx="44.39" cy="54.22" r="4" stroke="gray"></circle><circle cx="44.39" cy="80.05" r="4" stroke="gray"></circle><path d="M44.39 76.05V58.22m3.44-6.03 18.72-11.05" stroke="gray"></path></g>', 1);
const _hoisted_3$s = [
  _hoisted_2$L
];
function render$L(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$L, _hoisted_3$s);
}
const TechnologyGraphic = { render: render$L };
const _hoisted_1$K = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$K = /* @__PURE__ */ vue.createStaticVNode('<g clip-path="url(#clip0_1918_3551)" stroke-width="1.29" stroke-miterlimit="10"><path d="M6 79.91h84.63M37.04 33.2l3.26 3.26M59.69 33.08l-3.41 3.42" stroke="#FF000F"></path><path d="M69.72 18.64h-6.15a4.49 4.49 0 0 0-4.49 4.49v6.15a4.49 4.49 0 0 0 4.49 4.49h6.15a4.49 4.49 0 0 0 4.49-4.49v-6.15a4.49 4.49 0 0 0-4.49-4.49ZM33.13 18.64h-6.15a4.49 4.49 0 0 0-4.49 4.49v6.15a4.49 4.49 0 0 0 4.49 4.49h6.15a4.49 4.49 0 0 0 4.49-4.49v-6.15a4.49 4.49 0 0 0-4.49-4.49ZM69.72 55.08h-6.15a4.49 4.49 0 0 0-4.49 4.49v6.15a4.49 4.49 0 0 0 4.49 4.49h6.15a4.49 4.49 0 0 0 4.49-4.49v-6.15a4.49 4.49 0 0 0-4.49-4.49ZM33.13 55.08h-6.15a4.49 4.49 0 0 0-4.49 4.49v6.15a4.49 4.49 0 0 0 4.49 4.49h6.15a4.49 4.49 0 0 0 4.49-4.49v-6.15a4.49 4.49 0 0 0-4.49-4.49Z" stroke="gray"></path><path d="m59.78 55.85-3.26-3.25M37.12 55.98l3.42-3.42" stroke="#FF000F"></path><path d="M51.85 35.89h-7a5.12 5.12 0 0 0-5.12 5.12v7a5.12 5.12 0 0 0 5.12 5.12h7a5.12 5.12 0 0 0 5.12-5.12v-7a5.12 5.12 0 0 0-5.12-5.12Z" stroke="gray"></path></g><defs><clipPath id="clip0_1918_3551"><path fill="#fff" transform="translate(6 18)" d="M0 0h84.63v62.55H0z"></path></clipPath></defs>', 2);
const _hoisted_4$o = [
  _hoisted_2$K
];
function render$K(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$K, _hoisted_4$o);
}
const ComplexPartGraphic = { render: render$K };
const _hoisted_1$J = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$J = /* @__PURE__ */ vue.createStaticVNode('<g clip-path="url(#clip0_1916_3527)" stroke-width="1.29"><path d="M6 79.83h84.63" stroke="#FF000F" stroke-miterlimit="10"></path><path d="M47.43 55.88c-1.04-6.83-6.95-12.1-14.06-12.1-1.23 0-2.42.17-3.55.47M48.7 27.4l-5.22 8.57c-.26.43-.26.95 0 1.38.26.43.74.69 1.26.69h13.51" stroke="#FF000F" stroke-linecap="round" stroke-linejoin="round"></path><path d="M36.21 24.55h-7.95c-.73.07-1.29.69-1.29 1.42V45.3c-4.63 2.35-7.82 7.16-7.82 12.7 0 7.85 6.38 14.24 14.22 14.24 7.84 0 13.83-6.01 14.2-13.53h12.11c.79 0 1.42-.64 1.42-1.42V38.03h14.93c.52 0 1-.26 1.26-.69.26-.43.26-.95 0-1.38L61.65 10.34c-.27-.45-.79-.71-1.33-.69-.5.02-.95.28-1.2.69l-8.69 14.22H35.45" stroke="gray" stroke-miterlimit="10"></path><path d="M61.09 35.28v-9.3c0-.79-.64-1.42-1.42-1.42H53.8M26.97 48.58v8.72c0 .79.64 1.42 1.42 1.42H44.7" stroke="#FF000F" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_1916_3527"><path fill="#fff" transform="translate(6 9)" d="M0 0h84.63v71.47H0z"></path></clipPath></defs>', 2);
const _hoisted_4$n = [
  _hoisted_2$J
];
function render$J(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$J, _hoisted_4$n);
}
const EasilyCombineGraphic = { render: render$J };
const _hoisted_1$I = {
  width: "96",
  height: "96",
  "data-name": "Layer 1",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$I = /* @__PURE__ */ vue.createStaticVNode('<g fill="none" stroke-miterlimit="10" stroke-width="1.5"><g stroke="gray"><path d="M52.59 58.09V45.85h12.25M52.59 45.85 75 68.26M43.41 24.42v12.25H31.16M43.41 36.67 21 14.26"></path></g><g stroke="#ff000f"><path d="M64.84 36.67H52.59V24.42M52.59 36.67 75 14.26M31.16 45.85h12.25v12.24M43.41 45.85 21 68.26M13.26 81.52h69.48"></path></g></g>', 1);
const _hoisted_3$r = [
  _hoisted_2$I
];
function render$I(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$I, _hoisted_3$r);
}
const ContactDarkGraphic = { render: render$I };
const _hoisted_1$H = {
  width: "96",
  height: "96",
  "data-name": "Layer 1",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$H = /* @__PURE__ */ vue.createStaticVNode('<g fill="none" stroke-miterlimit="10" stroke-width="1.5"><g stroke="#bebebe"><path d="M52.59 58.09V45.85h12.25M52.59 45.85 75 68.26M43.41 24.42v12.25H31.16M43.41 36.67 21 14.26"></path></g><g stroke="#ff000f"><path d="M64.84 36.67H52.59V24.42M52.59 36.67 75 14.26M31.16 45.85h12.25v12.24M43.41 45.85 21 68.26M13.26 81.52h69.48"></path></g></g>', 1);
const _hoisted_3$q = [
  _hoisted_2$H
];
function render$H(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$H, _hoisted_3$q);
}
const ContactLightGraphic = { render: render$H };
const _hoisted_1$G = {
  width: "96",
  height: "96",
  "data-name": "Layer 1",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$G = /* @__PURE__ */ vue.createStaticVNode('<path d="M48.2 61.955h-1.77l-22-38.16h14.8v-10.09h16.19v10.09h14.8zm-.9-1.5 20.3-35.16H53.92v-10.09H40.78v10.09H27.07z" fill="gray"></path><path fill="#ff000f" d="M46.43 61.955h1.77l22.02-38.16h-1.76z"></path><g fill="none" stroke-miterlimit="10" stroke-width="1.5"><path stroke="#ff000f" d="M13.26 81.545h69.48"></path><g stroke="gray"><path d="M13.17 75.505A337.77 337.77 0 0 0 48 77.225a336.62 336.62 0 0 0 34.83-1.72M13 62.455a103 103 0 0 0 35 6 103 103 0 0 0 35-6M13.09 69.455A178 178 0 0 0 48 72.825a177.27 177.27 0 0 0 34.91-3.37"></path></g></g>', 3);
const _hoisted_5$9 = [
  _hoisted_2$G
];
function render$G(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$G, _hoisted_5$9);
}
const LoadDarkGraphic = { render: render$G };
const _hoisted_1$F = {
  width: "96",
  height: "96",
  "data-name": "Layer 1",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$F = /* @__PURE__ */ vue.createStaticVNode('<path d="M48.2 61.955h-1.77l-22-38.16h14.8v-10.09h16.19v10.09h14.8zm-.9-1.5 20.3-35.16H53.92v-10.09H40.78v10.09H27.07z" fill="#bebebe"></path><path fill="#ff000f" d="M46.43 61.955h1.77l22.02-38.16h-1.76z"></path><g fill="none" stroke-miterlimit="10" stroke-width="1.5"><path stroke="#ff000f" d="M13.26 81.545h69.48"></path><g stroke="#bebebe"><path d="M13.17 75.505A337.77 337.77 0 0 0 48 77.225a336.62 336.62 0 0 0 34.83-1.72M13 62.455a103 103 0 0 0 35 6 103 103 0 0 0 35-6M13.09 69.455A178 178 0 0 0 48 72.825a177.27 177.27 0 0 0 34.91-3.37"></path></g></g>', 3);
const _hoisted_5$8 = [
  _hoisted_2$F
];
function render$F(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$F, _hoisted_5$8);
}
const LoadLightGraphic = { render: render$F };
const _hoisted_1$E = {
  width: "96",
  height: "96",
  "data-name": "Layer 1",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$E = /* @__PURE__ */ vue.createStaticVNode('<g fill="none" stroke-width="1.5"><path stroke="#ff000f" stroke-miterlimit="10" d="M7.47 81.535h81.06"></path><path d="m56.33 44.995-3.75-6.48v-20.72h-9.16v20.72l-19 33a2 2 0 0 0 1.73 3h43.73a2 2 0 0 0 1.73-3l-5.68-9.83" stroke="gray" stroke-miterlimit="10"></path><path stroke="#ff000f" d="M40.61 14.465h14.78"></path><g stroke="gray"><path stroke-linejoin="round" d="m59.34 43.085 1.34 5.68 8.78-.41M49.64 48.175l5.01 11.12 13.06-1.48"></path><path stroke-miterlimit="10" d="m69.89 32.815-24.18 41.88"></path></g><path d="M55.21 45.145c-7.67 3.07-14.59 9.71-10.02 17.71 4.25 7.41 16.21 6.58 21.07-1.55 4.39-7.4 3.55-29.45 3.55-29.45s-7.32 10.38-14.6 13.29z" stroke="#ff000f" stroke-miterlimit="10"></path><path stroke="gray" stroke-miterlimit="10" d="m54.65 59.295-8.94 15.4"></path></g>', 1);
const _hoisted_3$p = [
  _hoisted_2$E
];
function render$E(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$E, _hoisted_3$p);
}
const UspClassViDarkGraphic = { render: render$E };
const _hoisted_1$D = {
  width: "96",
  height: "96",
  "data-name": "Layer 1",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$D = /* @__PURE__ */ vue.createStaticVNode('<g fill="none" stroke-width="1.5"><path stroke="#ff000f" stroke-miterlimit="10" d="M7.47 81.535h81.06"></path><path d="m56.33 44.995-3.75-6.48v-20.72h-9.16v20.72l-19 33a2 2 0 0 0 1.73 3h43.73a2 2 0 0 0 1.73-3l-5.68-9.83" stroke="#bebebe" stroke-miterlimit="10"></path><path stroke="#ff000f" d="M40.61 14.465h14.78"></path><g stroke="#bebebe"><path stroke-linejoin="round" d="m59.34 43.085 1.34 5.68 8.78-.41M49.64 48.175l5.01 11.12 13.06-1.48"></path><path stroke-miterlimit="10" d="m69.89 32.815-24.18 41.88"></path></g><path d="M55.21 45.145c-7.67 3.07-14.59 9.71-10.02 17.71 4.25 7.41 16.21 6.58 21.07-1.55 4.39-7.4 3.55-29.45 3.55-29.45s-7.32 10.38-14.6 13.29z" stroke="#ff000f" stroke-miterlimit="10"></path><path stroke="#bebebe" stroke-miterlimit="10" d="m54.65 59.295-8.94 15.4"></path></g>', 1);
const _hoisted_3$o = [
  _hoisted_2$D
];
function render$D(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$D, _hoisted_3$o);
}
const UspClassViLightGraphic = { render: render$D };
const _hoisted_1$C = {
  width: "96",
  height: "96",
  "data-name": "Layer 1",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$C = /* @__PURE__ */ vue.createStaticVNode('<g transform="translate(-22 -21.444)" fill="none" stroke-miterlimit="10" stroke-width="1.5"><path d="M32.67 100.48h74.66" stroke="#ff000f"></path><circle cx="69.94" cy="65.18" r="7.13" stroke="#bebebe"></circle><path d="m60.97 74.6-3.67-2.12v-4.24h-5.15v-6.12h5.15v-4.24l3.67-2.12-2.57-4.46 5.29-3.06 2.58 4.46 3.67-2.12 3.67 2.12 2.58-4.46 5.3 3.06-2.58 4.46 3.67 2.12v4.24h5.15v6.12h-5.15v4.24l-3.67 2.12 2.58 4.46-5.3 3.06-2.58-4.46-3.67 2.12-3.67-2.12-2.58 4.46-5.29-3.06z" stroke="#bebebe"></path><path d="M70 38.43 48.45 43.6v23.86c0 8.02 4.21 15.46 11.09 19.59L70 93.33l10.46-6.28a22.854 22.854 0 0 0 11.09-19.59V43.6z" stroke="#ff000f"></path></g>', 1);
const _hoisted_3$n = [
  _hoisted_2$C
];
function render$C(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$C, _hoisted_3$n);
}
const MechanicalStressGraphic = { render: render$C };
const _hoisted_1$B = {
  width: "96",
  height: "96",
  "data-name": "Layer 1",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$B = /* @__PURE__ */ vue.createStaticVNode('<g fill="none" stroke-miterlimit="10" stroke-width="1.5"><path stroke="#ff000f" d="M10.67 81.231h74.66M85.33 81.231H10.67M81.22 60.691v-9.3h-9.3"></path><path stroke="#ff000f" d="m30.69 51.391 25.26 25.27 25.27-25.27"></path><path stroke="#ff000f" d="M65.31 60.691v-9.3h-9.3"></path><path stroke="#ff000f" d="m65.31 51.391-25.26 25.27-25.27-25.27"></path><path stroke="#bebebe" d="m44.01 23.971-6.3 10.92c-.62 1.07-.91 2.32-.72 3.54.56 3.63 3.52 6.36 6.65 6.51 3.28.16 6.59-2.52 7.33-6.27.26-1.31-.01-2.66-.68-3.82-2.09-3.63-4.19-7.25-6.28-10.88zM54.9 15.601l-3.72 6.45c-.36.63-.54 1.37-.42 2.09.33 2.14 2.08 3.76 3.93 3.85 1.94.09 3.89-1.49 4.33-3.7.15-.77 0-1.57-.4-2.25-1.24-2.14-2.47-4.28-3.71-6.42z"></path></g>', 1);
const _hoisted_3$m = [
  _hoisted_2$B
];
function render$B(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$B, _hoisted_3$m);
}
const MoistureAbsorptionGraphic = { render: render$B };
const _hoisted_1$A = {
  width: "96",
  height: "96",
  "data-name": "Layer 1",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$A = /* @__PURE__ */ vue.createStaticVNode('<g fill="none" stroke-miterlimit="10" stroke-width="1.5"><path stroke="#ff000f" d="M10.67 81.231h74.66M85.33 81.231H10.67M81.22 60.691v-9.3h-9.3"></path><path stroke="#ff000f" d="m30.69 51.391 25.26 25.27 25.27-25.27"></path><path stroke="#ff000f" d="M65.31 60.691v-9.3h-9.3"></path><path stroke="#ff000f" d="m65.31 51.391-25.26 25.27-25.27-25.27"></path><path stroke="gray" d="m44.01 23.971-6.3 10.92c-.62 1.07-.91 2.32-.72 3.54.56 3.63 3.52 6.36 6.65 6.51 3.28.16 6.59-2.52 7.33-6.27.26-1.31-.01-2.66-.68-3.82-2.09-3.63-4.19-7.25-6.28-10.88zM54.9 15.601l-3.72 6.45c-.36.63-.54 1.37-.42 2.09.33 2.14 2.08 3.76 3.93 3.85 1.94.09 3.89-1.49 4.33-3.7.15-.77 0-1.57-.4-2.25-1.24-2.14-2.47-4.28-3.71-6.42z"></path></g>', 1);
const _hoisted_3$l = [
  _hoisted_2$A
];
function render$A(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$A, _hoisted_3$l);
}
const MoistureAbsorptionDarkGraphic = { render: render$A };
const _hoisted_1$z = {
  width: "96",
  height: "96",
  "data-name": "Layer 1",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$z = /* @__PURE__ */ vue.createElementVNode("g", {
  fill: "none",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5"
}, [
  /* @__PURE__ */ vue.createElementVNode("path", {
    stroke: "#ff000f",
    d: "M10.67 79.305h74.66M57.12 16.695c0 5.04-4.08 9.12-9.12 9.12s-9.12-4.08-9.12-9.12M48 29.325v5.98M66.61 16.695h-5.98M35.37 16.695h-5.98M61.16 29.855l-4.23-4.23M34.84 29.855l4.23-4.23"
  }),
  /* @__PURE__ */ vue.createElementVNode("path", {
    stroke: "#bebebe",
    d: "M10.67 41.545h74.66M35.36 53.515v-5.73h5.73M35.36 47.785l6.07 6.07M60.63 53.515v-5.73H54.9M60.63 47.785l-6.07 6.07M60.63 67.325v5.73H54.9M60.63 73.055l-6.07-6.07M35.36 67.325v5.73h5.73M35.36 73.055l6.07-6.07"
  }),
  /* @__PURE__ */ vue.createElementVNode("path", {
    stroke: "#ff000f",
    d: "m43.88 56.305 8.23 8.23M52.11 56.305l-8.23 8.23"
  })
], -1);
const _hoisted_3$k = [
  _hoisted_2$z
];
function render$z(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$z, _hoisted_3$k);
}
const ThermalExpansionGraphic = { render: render$z };
const _hoisted_1$y = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$y = /* @__PURE__ */ vue.createElementVNode("g", {
  stroke: "gray",
  fill: "none",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5"
}, [
  /* @__PURE__ */ vue.createElementVNode("path", { d: "M56.66 62.435 48 71.095l-8.66-8.66M48 71.095v-57.41" })
], -1);
const _hoisted_3$j = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "#ff000f",
  fill: "none",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M83 79.525c0 1.12-.92 2.04-2.04 2.04H15.04c-1.12 0-2.04-.92-2.04-2.04"
}, null, -1);
const _hoisted_4$m = [
  _hoisted_2$y,
  _hoisted_3$j
];
function render$y(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$y, _hoisted_4$m);
}
const DownloadCenterGraphic = { render: render$y };
const _hoisted_1$x = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$x = /* @__PURE__ */ vue.createStaticVNode('<path stroke="#ff000f" fill="none" stroke-miterlimit="10" stroke-width="1.5" d="M13 81.955h70"></path><g fill="none" stroke-miterlimit="10" stroke-width="1.5"><path class="cls-2" stroke="gray" d="m50.57 38.265-11.1-11.09c0-.13 1.74-5.64-2.68-10.06-2.43-2.43-5.94-3.48-9.28-2.84l3.9 3.9c.95.97.95 2.52 0 3.48l-3.34 3.33c-.95.95-2.51.95-3.47 0l-3.9-3.9c-.62 3.33.42 6.83 2.85 9.26 4.45 4.45 9.91 2.68 10.06 2.68l8.24 8.24m12.16-.9-9.13 3.89 5.55 5.59 7.44 7.43v.02l-.11.5c-.77 3.46.28 7.03 2.79 9.54 2.47 2.46 5.91 3.5 9.27 2.85l-3.9-3.9c-.95-.97-.95-2.53 0-3.48l3.34-3.33c.95-.95 2.51-.95 3.47 0l3.9 3.9c.63-3.33-.41-6.84-2.84-9.28a10.284 10.284 0 0 0-9.54-2.79l-.5.11h-.02l-10.28-10.28"></path><path stroke="#ff000f" d="m75.16 15.735-1.48-1.48-8.13 5.29v.01l-1.14 4.18-17.92 17.91"></path><path stroke="gray" d="m49.26 44.425 17.91-17.92 4.18-1.14h.01l5.29-8.13-1.48-1.48M43.576 38.747l8.584 8.584L27.772 71.72l-8.584-8.584z"></path></g>', 2);
const _hoisted_4$l = [
  _hoisted_2$x
];
function render$x(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$x, _hoisted_4$l);
}
const MaskGraphic = { render: render$x };
const _hoisted_1$w = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$w = /* @__PURE__ */ vue.createStaticVNode('<path stroke="#ff000f" stroke-miterlimit="10" fill="none" stroke-width="1.5" d="M13 81.555h70"></path><path class="cls-4" fill="#ff000f" d="M59.61 59.365v-.96h1.17v.96zm1.17.66v4.26h-1.17v-4.26z"></path><rect stroke-miterlimit="10" fill="none" stroke-width="1.5" stroke="gray" x="22.21" y="17.415" width="51.58" height="53.98" rx="2" ry="2"></rect><path fill="none" stroke-width="1.5" stroke="gray" stroke-linejoin="round" d="M48 13.695v7.44M35.11 13.695v7.44M60.89 13.695v7.44M29.89 31.185h36.22M29.89 39.265h36.22M29.89 47.345h36.22M29.89 55.425H48"></path><circle stroke="#ff000f" stroke-miterlimit="10" fill="none" stroke-width="1.5" cx="60.19" cy="61.345" r="5.92"></circle>', 5);
const _hoisted_7$4 = [
  _hoisted_2$w
];
function render$w(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$w, _hoisted_7$4);
}
const OrderInformationGraphic = { render: render$w };
const _hoisted_1$v = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$v = /* @__PURE__ */ vue.createElementVNode("path", {
  class: "cls-2",
  fill: "none",
  "stroke-miterlimit": "10",
  stroke: "#ff000f",
  "stroke-width": "1.5",
  d: "M13 76.42h70"
}, null, -1);
const _hoisted_3$i = /* @__PURE__ */ vue.createElementVNode("g", {
  stroke: "gray",
  "stroke-width": "1.5",
  fill: "none",
  "stroke-miterlimit": "10"
}, [
  /* @__PURE__ */ vue.createElementVNode("path", { d: "M67.72 63a3.26 3.26 0 1 1-6.521-.001A3.26 3.26 0 0 1 67.72 63zM45.57 63a3.26 3.26 0 1 1-6.521-.001A3.26 3.26 0 0 1 45.57 63zM34.03 45.31h34.63c.81 0 1.5-.49 1.7-1.21l5.12-14.87H28.4m-7.88-9.65h3.73c.49 0 .86.29.98.75l11.71 32.85a3.28 3.28 0 0 0 3.12 2.31h28.6" })
], -1);
const _hoisted_4$k = [
  _hoisted_2$v,
  _hoisted_3$i
];
function render$v(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$v, _hoisted_4$k);
}
const OrderingProductsGraphic = { render: render$v };
const _hoisted_1$u = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$u = /* @__PURE__ */ vue.createStaticVNode('<path stroke="#ff000f" fill="none" stroke-miterlimit="10" stroke-width="1.5" d="M13 76.05h70"></path><g transform="translate(-22 -27.88)"><rect fill="gray" x="77.5" y="68.02" width="3.96" height="3.96" rx="1.98" ry="1.98"></rect><path fill="none" stroke-miterlimit="10" stroke-width="1.5" stroke="gray" d="M79.48 70V56.4"></path><path stroke="#ff000f" fill="none" stroke-miterlimit="10" stroke-width="1.5" d="M38.35 70h10M44.42 60h10M40.86 65h10M44.42 80h10M40.86 75h10"></path><circle fill="none" stroke-miterlimit="10" stroke-width="1.5" stroke="gray" cx="79.48" cy="70" r="22.17"></circle><path fill="none" stroke-miterlimit="10" stroke-width="1.5" stroke="gray" d="M79.48 69.96h11.6"></path><circle fill="none" stroke-miterlimit="10" stroke-width="1.5" stroke="gray" cx="79.48" cy="70" r="18.59"></circle></g>', 2);
const _hoisted_4$j = [
  _hoisted_2$u
];
function render$u(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$u, _hoisted_4$j);
}
const PricingLeadTimesGraphic = { render: render$u };
const _hoisted_1$t = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$t = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "#ff000f",
  "stroke-miterlimit": "10",
  fill: "none",
  "stroke-width": "1.5",
  d: "M13 81.93h70"
}, null, -1);
const _hoisted_3$h = /* @__PURE__ */ vue.createElementVNode("g", {
  fill: "none",
  "stroke-width": "1.5",
  stroke: "gray"
}, [
  /* @__PURE__ */ vue.createElementVNode("path", {
    "stroke-miterlimit": "10",
    d: "M28.82 14.07H76.4c1.1 0 2 .9 2 2v53.7c0 1.1-.9 2-2 2H26.82v-55.7c0-1.1.9-2 2-2zM26.82 31.56h-9.21v31c0 5.09 4.12 9.21 9.21 9.21z"
  }),
  /* @__PURE__ */ vue.createElementVNode("path", {
    "stroke-linejoin": "round",
    d: "M34.49 36.51h36.23M52.61 42.92h18.11M34.49 55.74h36.23M52.61 49.33h18.11M34.49 62.15h36.23M35.23 41.04h14.02V51.2H35.23zM35.23 23.68h35.49v6.41H35.23z"
  })
], -1);
const _hoisted_4$i = [
  _hoisted_2$t,
  _hoisted_3$h
];
function render$t(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$t, _hoisted_4$i);
}
const UpToDateGraphic = { render: render$t };
const _hoisted_1$s = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$s = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "#ff000f",
  fill: "none",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "m48 16.621-21.55 5.17v23.86c0 8.02 4.21 15.46 11.09 19.59L48 71.521l10.46-6.28a22.854 22.854 0 0 0 11.09-19.59v-23.86zM7.47 79.401h81.06"
}, null, -1);
const _hoisted_3$g = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "gray",
  fill: "none",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M43.6 47.221a6.902 6.902 0 0 0-2.52 5.34c0 3.82 3.1 6.92 6.92 6.92a6.922 6.922 0 0 0 4.27-12.37v-16.21c0-2.34-1.92-4.26-4.26-4.26s-4.26 1.92-4.26 4.26v16.21l-.14.11M48 33.331v16.5"
}, null, -1);
const _hoisted_4$h = /* @__PURE__ */ vue.createElementVNode("circle", {
  stroke: "gray",
  fill: "none",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  cx: "48",
  cy: "52.561",
  r: "2.73"
}, null, -1);
const _hoisted_5$7 = /* @__PURE__ */ vue.createElementVNode("path", {
  stroke: "gray",
  fill: "none",
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M55.85 31.161h5.61M55.85 35.501h3.61M55.85 39.841h5.61M55.85 44.191h3.61"
}, null, -1);
const _hoisted_6$3 = [
  _hoisted_2$s,
  _hoisted_3$g,
  _hoisted_4$h,
  _hoisted_5$7
];
function render$s(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$s, _hoisted_6$3);
}
const TemperatureGraphic = { render: render$s };
const _hoisted_1$r = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$r = /* @__PURE__ */ vue.createStaticVNode('<path d="M25.09 30.549s34.78 0 41.66 30.85" style="stroke-width:1.63px;stroke:gray;fill:none;stroke-miterlimit:10;"></path><path style="stroke:gray;stroke-width:1.62px;fill:none;stroke-miterlimit:10;" d="M94.94 93.33H41.43V39.64" transform="translate(-22 -22.231)"></path><path style="stroke:gray;stroke-width:1.62px;fill:none;stroke-miterlimit:10;" d="m91.73 89.9 3.39 3.42-3.38 3.45M38 43.04l3.42-3.4 3.45 3.39" transform="translate(-22 -22.231)"></path><path style="stroke-dasharray:0 0 1.85 1.85;stroke-width:1.63px;stroke:#ff000f;fill:none;stroke-miterlimit:10;" d="M67.58 35.809H25.07"></path><path style="stroke:#ff000f;fill:none;stroke-miterlimit:10;stroke-width:1.5px;" d="M7.47 78.979h81.06"></path>', 5);
const _hoisted_7$3 = [
  _hoisted_2$r
];
function render$r(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$r, _hoisted_7$3);
}
const DimensionStabilityGraphic = { render: render$r };
const _hoisted_1$q = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$q = /* @__PURE__ */ vue.createStaticVNode('<path style="stroke-width:1.5px;fill:none;stroke-miterlimit:10;stroke:#ff000f;" d="M13 80.185h70"></path><g transform="translate(-22 -21.025)"><rect x="47.25" y="36.84" width="45.5" height="56.93" rx="1.93" ry="1.93" style="stroke:gray;stroke-width:1.5px;fill:none;stroke-miterlimit:10;"></rect><circle cx="56.62" cy="85.12" r="3.79" style="stroke:gray;stroke-width:1.5px;fill:none;stroke-miterlimit:10;"></circle><circle cx="56.62" cy="74.82" r="3.79" style="stroke:gray;stroke-width:1.5px;fill:none;stroke-miterlimit:10;"></circle><circle cx="56.62" cy="64.51" r="3.79" style="stroke:gray;stroke-width:1.5px;fill:none;stroke-miterlimit:10;"></circle><circle cx="70" cy="85.12" r="3.79" style="stroke:gray;stroke-width:1.5px;fill:none;stroke-miterlimit:10;"></circle><circle cx="70" cy="74.82" r="3.79" style="stroke:gray;stroke-width:1.5px;fill:none;stroke-miterlimit:10;"></circle><circle cx="70" cy="64.51" r="3.79" style="stroke:gray;stroke-width:1.5px;fill:none;stroke-miterlimit:10;"></circle><rect x="52.83" y="41.69" width="34.33" height="14.03" rx="1.23" ry="1.23" style="stroke:gray;stroke-width:1.5px;fill:none;stroke-miterlimit:10;"></rect><path d="M87.17 85.12c0 2.09-1.7 3.79-3.79 3.79s-3.79-1.7-3.79-3.79v-10.3c0-2.09 1.7-3.79 3.79-3.79s3.79 1.7 3.79 3.79z" style="stroke:gray;stroke-width:1.5px;fill:none;stroke-miterlimit:10;"></path><circle cx="83.38" cy="64.51" r="3.79" style="stroke:gray;stroke-width:1.5px;fill:none;stroke-miterlimit:10;"></circle></g><path style="fill:none;stroke-miterlimit:10;stroke:#ff000f;stroke-width:1.5px;" d="M7.47 80.185h81.06"></path>', 3);
const _hoisted_5$6 = [
  _hoisted_2$q
];
function render$q(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$q, _hoisted_5$6);
}
const CalculatorGraphic = { render: render$q };
const _hoisted_1$p = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$p = /* @__PURE__ */ vue.createStaticVNode('<path fill="none" stroke-miterlimit="10" stroke-width="1.5" stroke="#ff000f" d="M7.47 79.802h81.06"></path><g transform="translate(-22 -21.408)" fill="none" stroke-miterlimit="10" stroke-width="1.5"><circle stroke="gray" cx="70" cy="73.6" r="3.78"></circle><path stroke="#ff000f" d="M79.33 54.5c.5 1.46-.67 1.36-.67 1.36l-13.29-.02s-2.26.12-2.77-1.37l-1.96-5.78c-.5-1.48 1.37-2.77 1.37-2.77l10.54-8.1s.86-.79 1.36.67l5.44 16.02zM89.1 82.92c-1.46.5-1.36-.67-1.36-.67l.02-13.29s-.12-2.26 1.37-2.77l5.78-1.96c1.48-.5 2.77 1.37 2.77 1.37l8.1 10.54s.79.86-.67 1.36l-16.02 5.44z"></path><path stroke="gray" d="M56.24 93.33V73.59c0-7.6 6.16-13.76 13.76-13.76s13.76 6.16 13.76 13.76v19.74"></path><path stroke="#ff000f" d="M50.9 64.27c1.46-.5 1.36.67 1.36.67l-.02 13.29s.12 2.26-1.37 2.77l-5.78 1.96c-1.48.5-2.77-1.37-2.77-1.37l-8.1-10.54s-.79-.86.67-1.36l16.02-5.44z"></path><circle stroke="gray" cx="70" cy="73.6" r="10.54"></circle></g><rect fill="gray" transform="rotate(-15.18)" x="50.191" y="79.128" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="49.062" y="81.019" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="52.516" y="79.506" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="52.127" y="82.038" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="53.835" y="78.536" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="53.733" y="80.595" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.17)" x="57.639" y="78.448" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="57.351" y="81.752" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="64.426" y="85.985" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="59.197" y="79.433" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="55.603" y="81.469" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="54.893" y="82.984" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="56.88" y="80.123" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="58.856" y="81.798" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="60.658" y="78.427" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="50.87" y="83.778" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="47.793" y="80.117" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="47.939" y="82.041" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="49.821" y="80.47" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="51.519" y="78.644" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="51.748" y="81.179" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="54.625" y="79.504" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="55.383" y="78.954" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="61.614" y="79.455" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="62.494" y="78.431" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="52.256" y="83.773" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="51.515" y="87.067" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="55.59" y="84.879" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="55.541" y="87.314" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="57.14" y="85.852" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="53.374" y="87.484" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="56.62" y="83.352" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="58.327" y="84.862" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="52.725" y="85.412" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="53.83" y="84.278" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="49.928" y="82.309" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="47.379" y="85.666" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="50.87" y="85.418" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="48.861" y="85.119" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="48.62" y="83.814" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="48.34" y="87.061" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="49.986" y="86.574" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="56.048" y="88.776" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="60.734" y="83.816" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="60.616" y="81.47" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="58.858" y="83.363" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="64.081" y="81.522" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="64.541" y="84.273" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="66.137" y="81.79" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="62.83" y="84" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="64.562" y="79.74" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="65.882" y="84.643" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="62.195" y="81.752" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="64.921" y="82.864" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="58.655" y="85.898" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="58.596" y="88.333" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="62.831" y="87.214" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="62.779" y="89.658" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="64.429" y="88.03" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="60.941" y="89.731" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="62.51" y="86.188" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="65.568" y="87.197" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="60.619" y="85.668" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="60.952" y="87.463" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="46.801" y="83.783" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="64.881" y="77.43" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="66.099" y="79.607" width=".57" height=".57" rx=".29" ry=".29"></rect><rect fill="gray" transform="rotate(-15.18)" x="64.88" y="90.041" width=".57" height=".57" rx=".29" ry=".29"></rect>', 70);
const _hoisted_72 = [
  _hoisted_2$p
];
function render$p(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$p, _hoisted_72);
}
const CastNylonProductsGraphic = { render: render$p };
const _hoisted_1$o = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$o = /* @__PURE__ */ vue.createStaticVNode('<path d="m48 16.621-21.55 5.17v23.86c0 8.02 4.21 15.46 11.09 19.59L48 71.521l10.46-6.28a22.854 22.854 0 0 0 11.09-19.59v-23.86z" style="stroke-width:1.5px;fill:none;stroke:#ff000f;stroke-miterlimit:10;"></path><g transform="translate(-22 -21.809)"><path d="M79.29 56.21c0-5.82-5.36-8.84-11.42-7.92-3.9.59-7.05 3.73-7.16 7.67a9.289 9.289 0 0 0 4.33 8.11c.54.34.97.84 1.15 1.45.45 1.55 1.98 2.35 3.8 2.35s3.35-.8 3.8-2.35c.18-.62.63-1.11 1.17-1.46a9.269 9.269 0 0 0 4.32-7.85z" style="stroke:gray;stroke-linejoin:round;stroke-width:1.5px;fill:none;"></path><path d="M68.45 55.33c.1.98-.61 1.86-1.6 1.96s-1.86-.61-1.96-1.6.66-1.41 1.64-1.51 1.81.17 1.91 1.15zM71.55 55.33c-.1.98.61 1.86 1.6 1.96.98.1 1.86-.61 1.96-1.6s-.66-1.41-1.64-1.51-1.81.17-1.91 1.15zM69.32 60.14l-.67 1.32c-.17.34.08.75.46.75h1.77c.39 0 .64-.41.46-.75l-.67-1.32a.76.76 0 0 0-1.36 0z" style="stroke:gray;stroke-linejoin:round;stroke-width:1.5px;fill:none;"></path><rect transform="rotate(197.97 69.998 74.33)" x="58.12" y="72.36" width="23.75" height="3.94" rx="1.97" ry="1.97" style="stroke:gray;stroke-linejoin:round;stroke-width:1.5px;fill:none;"></rect><path d="m70.17 76.45-8.1 4.13c-.96.49-2.16.11-2.65-.86-.49-.96-.11-2.16.86-2.65l4.59-2.34M69.83 72.2l8.1-4.13c.96-.49 2.16-.11 2.65.86.49.96.11 2.16-.86 2.65l-4.59 2.34" style="stroke:gray;stroke-linejoin:round;stroke-width:1.5px;fill:none;"></path></g><path style="fill:none;stroke:#ff000f;stroke-miterlimit:10;stroke-width:1.5px;" d="M7.47 79.401h81.06"></path>', 3);
const _hoisted_5$5 = [
  _hoisted_2$o
];
function render$o(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$o, _hoisted_5$5);
}
const ChemicalResistanceGraphic = { render: render$o };
const _hoisted_1$n = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$n = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M94.56 38.39c-5.72-5.72-15.01-5.72-20.73 0L49.65 62.57l.33 20.4 20.4.33 24.18-24.18c5.72-5.72 5.72-15.01 0-20.73zM85.07 47.88 41.15 91.8M83.43 60.63h9.62M76.05 68.02h9.61M68.67 75.4h9.61M68.62 53.21v-9.62M61.24 60.59v-9.61",
  style: { "stroke": "gray", "stroke-width": "1.5px", "fill": "none", "stroke-miterlimit": "10" },
  transform: "translate(-22 -19.657)"
}, null, -1);
const _hoisted_3$f = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none", "stroke-miterlimit": "10", "stroke": "#ff000f", "stroke-width": "1.5px" },
  d: "M7.47 81.553h81.06"
}, null, -1);
const _hoisted_4$g = [
  _hoisted_2$n,
  _hoisted_3$f
];
function render$n(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$n, _hoisted_4$g);
}
const FeatherGraphic = { render: render$n };
const _hoisted_1$m = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$m = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m78.22 39.554-27.69 27.69c-1.4 1.4-3.67 1.4-5.07 0l-27.69-27.69",
  style: { "fill": "none", "stroke-miterlimit": "10", "stroke-width": "1.5px", "stroke": "gray" }
}, null, -1);
const _hoisted_3$e = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m73.23 38.334-23.12 23.12a2.988 2.988 0 0 1-4.23 0l-23.12-23.12",
  style: { "stroke": "#ff000f", "fill": "none", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
}, null, -1);
const _hoisted_4$f = /* @__PURE__ */ vue.createElementVNode("rect", {
  transform: "rotate(45)",
  x: "47.478",
  y: "-20.41",
  width: "26.01",
  height: "26.01",
  rx: "1.67",
  ry: "1.67",
  style: { "fill": "none", "stroke-miterlimit": "10", "stroke-width": "1.5px", "stroke": "gray" }
}, null, -1);
const _hoisted_5$4 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "stroke": "#ff000f", "fill": "none", "stroke-miterlimit": "10", "stroke-width": "1.5px" },
  d: "M7.47 76.164h81.06"
}, null, -1);
const _hoisted_6$2 = [
  _hoisted_2$m,
  _hoisted_3$e,
  _hoisted_4$f,
  _hoisted_5$4
];
function render$m(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$m, _hoisted_6$2);
}
const LowFrictionGraphic = { render: render$m };
const _hoisted_1$l = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$l = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none", "stroke-miterlimit": "10", "stroke-width": "1.5px", "stroke": "#ff000f" },
  d: "M7.47 76.446h81.06"
}, null, -1);
const _hoisted_3$d = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m34.04 61.186 48.59-28.03s.51-.29 1.18-.93c7.26-6.12.49-15.89-7.47-11.66-.09 0-.08.09-.17.1l-18.61 10.86-36.12-9.46-7.17 4.19 28.09 14.04-14.6 8.39-12.69-3.27-5.97 3.7 18.23 11.17c2.17 1.48 4.49 2.25 6.71.92z",
  style: { "fill-rule": "evenodd", "stroke": "gray", "fill": "none", "stroke-miterlimit": "10", "stroke-width": "1.5px" }
}, null, -1);
const _hoisted_4$e = [
  _hoisted_2$l,
  _hoisted_3$d
];
function render$l(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$l, _hoisted_4$e);
}
const PlaneGraphic = { render: render$l };
const _hoisted_1$k = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$k = /* @__PURE__ */ vue.createStaticVNode('<path style="fill:none;stroke-miterlimit:10;stroke:#ff000f;stroke-width:1.5px;" d="M7.47 77.185h81.06"></path><g transform="translate(-22 -24.025)"><path d="M65.36 58.67v-9.21c0-1.1-.9-2-2-2H47.41c-1.1 0-2 .9-2 2v41.89c0 1.1.9 2 2 2h15.95c1.1 0 2-.9 2-2V70.3M69.32 63.24V52.59c0-.44-.36-.8-.8-.8h-2.35c-.44 0-.8.36-.8.8M65.36 88.22c0 .44.36.8.8.8h2.35c.44 0 .8-.36.8-.8V65.61M69.32 81.12c0 .62.5 1.13 1.13 1.13h10.02c.62 0 1.13-.5 1.13-1.13 0 0 0-2.9 4.83-2.9h6.53c.51 0 .92-.41.92-.92V63.51c0-.51-.41-.92-.92-.92h-6.53c-4.83 0-4.83-2.9-4.83-2.9 0-.62-.5-1.13-1.13-1.13H70.45c-.62 0-1.13.5-1.13 1.13" style="stroke:gray;stroke-width:1.5px;fill:none;stroke-miterlimit:10;"></path><path d="M79.65 93.32h12.22c1.1 0 2-.9 2-2V75.88" style="stroke:gray;stroke-width:1.5px;fill:none;stroke-miterlimit:10;"></path><rect x="93.87" y="68.78" width="6.08" height="3.25" rx="1" ry="1" style="stroke:gray;stroke-width:1.5px;fill:none;stroke-miterlimit:10;"></rect><path d="M63.14 58.91c-1.16.49-1.93 1.39-2.43 2.32a6.889 6.889 0 0 0 0 6.51c.5.93 1.27 1.83 2.43 2.32.97.41 2.09.41 3.06 0 1.16-.49 1.93-1.39 2.43-2.32a6.889 6.889 0 0 0 0-6.51c-.5-.93-1.27-1.83-2.43-2.32a3.96 3.96 0 0 0-3.06 0z" style="stroke:gray;stroke-width:1.5px;fill:none;stroke-miterlimit:10;"></path><circle cx="64.67" cy="64.48" r="1.12" style="fill:gray;"></circle><circle cx="64.67" cy="61.29" r=".46" style="fill:gray;"></circle><circle cx="64.67" cy="67.68" r=".46" style="fill:gray;"></circle><path style="stroke:gray;stroke-width:1.5px;fill:none;stroke-miterlimit:10;" d="M41.68 60.36v-3.6M69.32 55.48h2.04M69.32 85.32h2.04"></path><path style="fill:none;stroke-miterlimit:10;stroke:#ff000f;stroke-width:1.5px;" d="M72.8 67.35h9.24v6.11H72.8z"></path><path style="stroke:gray;stroke-width:1.5px;fill:none;stroke-miterlimit:10;" d="M45.41 58.56h-5.36M47.94 43.73h3.61M49.75 47.46v-5.37M59.79 43.73h3.6M61.59 47.46v-5.37M41.68 72.16v-3.6M45.41 70.36h-5.36M41.68 84.04v-3.6M45.41 82.24h-5.36"></path></g>', 2);
const _hoisted_4$d = [
  _hoisted_2$k
];
function render$k(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$k, _hoisted_4$d);
}
const PumpsGraphic = { render: render$k };
const _hoisted_1$j = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$j = /* @__PURE__ */ vue.createStaticVNode('<path style="stroke:#ff000f;fill:none;stroke-miterlimit:10;stroke-width:1.5px;" d="M7.47 74.93h81.06"></path><rect transform="rotate(14.62)" x="29.122" y="13.61" width="16" height="16" rx="2.5" ry="2.5" style="fill:none;stroke-miterlimit:10;stroke-width:1.5px;stroke:gray;"></rect><path d="M11.7 40.29c33.43 8.72 73.38 19.15 73.38 19.15" style="stroke:#ff000f;fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></path><path d="M44.29 33.89c16.31 4.26 30.56 7.97 37.06 9.67M10.92 43.26C44.35 51.98 84.3 62.41 84.3 62.41" style="fill:none;stroke-miterlimit:10;stroke-width:1.5px;stroke:gray;"></path><path transform="translate(-22 -26.28)" style="fill:none;stroke-miterlimit:10;stroke-width:1.5px;stroke:gray;" d="m100.12 64.19 3.22 5.64-5.61 3.32"></path>', 5);
const _hoisted_7$2 = [
  _hoisted_2$j
];
function render$j(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$j, _hoisted_7$2);
}
const ReleaseQualityProductsGraphic = { render: render$j };
const _hoisted_1$i = {
  width: "96",
  height: "96",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$i = /* @__PURE__ */ vue.createStaticVNode('<path style="stroke:#ff000f;fill:none;stroke-miterlimit:10;stroke-width:1.5px;" d="M7.47 80.19h81.06"></path><g transform="translate(-22 -21.02)"><rect x="48.27" y="43.58" width="43.45" height="43.45" rx="5.78" ry="5.78" style="stroke:gray;fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></rect><rect x="56.83" y="52.13" width="26.34" height="26.34" rx="3.5" ry="3.5" style="stroke:gray;fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></rect><path style="stroke-linecap:round;stroke:gray;fill:none;stroke-miterlimit:10;stroke-width:1.5px;" d="M56.83 43.58v-6.75M63.1 43.58v-6.75M76.9 43.58v-6.75M83.17 43.58v-6.75M56.83 93.77v-6.74M63.1 93.77v-6.74M76.9 93.77v-6.74M83.17 93.77v-6.74M91.73 52.13h6.74M91.73 58.4h6.74M91.73 72.2h6.74M91.73 78.47h6.74M41.53 52.13h6.74M41.53 58.4h6.74M41.53 72.2h6.74M41.53 78.47h6.74"></path></g>', 2);
const _hoisted_4$c = [
  _hoisted_2$i
];
function render$i(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$i, _hoisted_4$c);
}
const WearstripProfilesGraphic = { render: render$i };
const _hoisted_1$h = {
  width: "96",
  height: "96",
  "data-name": "Layer 1",
  viewBox: "0 0 96 96",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$h = /* @__PURE__ */ vue.createStaticVNode('<g transform="translate(-22 -34.405)"><rect transform="rotate(-15.18)" x="44.196" y="94.225" width="4.36" height="4.36" rx="2.18" style="stroke:gray;fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></rect><rect transform="rotate(-15.18)" x="46.806" y="84.601" width="4.36" height="4.36" rx="2.18" style="stroke:gray;fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></rect><rect transform="rotate(-15.18)" x="40.191" y="87.992" width="4.36" height="4.36" rx="2.18" style="stroke:gray;fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></rect><rect transform="rotate(-15.005)" x="51.157" y="91.263" width="4.378" height="4.378" rx="2.189" style="stroke:gray;fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></rect><rect transform="rotate(-15.18)" x="42.809" y="78.32" width="4.36" height="4.36" rx="2.18" style="stroke:gray;fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></rect><rect transform="rotate(-15.005)" x="53.778" y="81.54" width="4.378" height="4.378" rx="2.189" style="stroke:gray;fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></rect><rect transform="rotate(-15.005)" x="36.86" y="82.175" width="4.378" height="4.378" rx="2.189" style="stroke:gray;fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></rect><rect transform="rotate(-60.18)" x="-23.67" y="103.03" width="4.36" height="4.36" rx="2.18" style="stroke:gray;fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></rect><rect transform="rotate(-15.005)" x="33.22" y="75.981" width="4.378" height="4.378" rx="2.189" style="stroke:gray;fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></rect><rect transform="rotate(-60.18)" x="-16.809" y="105" width="4.36" height="4.36" rx="2.18" style="stroke:gray;fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></rect><path d="M95.23 63.38 72.12 86.49a3 3 0 0 1-4.24 0L44.77 63.38M29.47 101.21h81.06" style="stroke:#ff000f;fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></path><path d="M100.22 64.6 72.53 92.28a3.57 3.57 0 0 1-5.06 0L39.78 64.6" style="stroke:gray;fill:none;stroke-miterlimit:10;stroke-width:1.5px;"></path></g>', 1);
const _hoisted_3$c = [
  _hoisted_2$h
];
function render$h(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$h, _hoisted_3$c);
}
const LiningSolutionsGraphic = { render: render$h };
const _hoisted_1$g = {
  width: "96",
  height: "96",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$g = /* @__PURE__ */ vue.createStaticVNode('<path d="M88.68 108.8c-1.2 0-2.41-.29-3.53-.88l-12.68-6.67c-1.55-.82-3.4-.82-4.95 0l-12.68 6.67a7.513 7.513 0 0 1-7.97-.58 7.518 7.518 0 0 1-3.01-7.4l2.42-14.12c.3-1.72-.28-3.48-1.53-4.71l-10.26-10c-2.08-2.03-2.81-5-1.92-7.76.9-2.76 3.24-4.73 6.11-5.15l14.18-2.06a5.303 5.303 0 0 0 4-2.91l6.34-12.85c1.28-2.6 3.88-4.22 6.79-4.22s5.5 1.62 6.79 4.22l6.34 12.85a5.303 5.303 0 0 0 4 2.91l14.18 2.06c2.87.42 5.21 2.39 6.11 5.15.9 2.76.16 5.73-1.92 7.76l-10.26 10a5.316 5.316 0 0 0-1.53 4.71l2.42 14.12a7.51 7.51 0 0 1-3.01 7.4 7.574 7.574 0 0 1-4.44 1.45ZM70 98.39c1.21 0 2.42.29 3.52.87l12.68 6.67c1.83.96 3.93.81 5.6-.4 1.67-1.22 2.47-3.16 2.12-5.2L91.5 86.21c-.42-2.46.39-4.96 2.18-6.7l10.26-10c1.48-1.44 1.98-3.48 1.34-5.45-.64-1.97-2.24-3.32-4.29-3.62l-14.18-2.06a7.605 7.605 0 0 1-5.7-4.14l-6.34-12.85c-.92-1.86-2.7-2.96-4.77-2.96s-3.85 1.11-4.77 2.96l-6.34 12.85a7.571 7.571 0 0 1-5.7 4.14l-14.18 2.06c-2.05.3-3.65 1.65-4.29 3.62-.64 1.97-.14 4 1.34 5.45l10.26 10a7.583 7.583 0 0 1 2.18 6.7l-2.42 14.12c-.35 2.04.44 3.98 2.12 5.2 1.67 1.22 3.77 1.37 5.6.4l12.68-6.67c1.1-.58 2.31-.87 3.52-.87Z" style="fill:#808689;"></path><path d="M97.76 70.65c-.64 0-1.29-.15-1.88-.45-.99-.5-1.72-1.36-2.06-2.41-.71-2.17.49-4.51 2.66-5.22s4.51.49 5.22 2.66-.49 4.51-2.66 5.22c-.42.14-.85.21-1.29.21Zm0-6.04c-.19 0-.39.03-.58.09-.99.32-1.54 1.39-1.22 2.38.16.48.49.87.94 1.1s.96.27 1.44.11c.48-.16.87-.49 1.1-.94s.27-.96.11-1.44c-.26-.8-1-1.31-1.8-1.31ZM87.17 103.29a4.089 4.089 0 0 1-3.36-1.71c-.65-.89-.91-1.99-.74-3.08.17-1.09.76-2.05 1.66-2.7.9-.65 1.99-.91 3.08-.74 1.09.17 2.05.76 2.7 1.66s.91 1.99.74 3.08a4.089 4.089 0 0 1-1.66 2.7c-.72.52-1.56.79-2.43.79Zm-.01-6.04c-.4 0-.78.12-1.11.36-.41.3-.68.74-.76 1.24-.08.5.04 1 .34 1.41.3.41.74.68 1.23.76.5.08 1-.04 1.41-.34.41-.3.68-.74.76-1.24.08-.5-.04-1-.34-1.41s-.74-.68-1.24-.76c-.1-.02-.2-.02-.3-.02ZM52.83 103.29c-.87 0-1.71-.27-2.43-.79-.9-.65-1.48-1.61-1.66-2.7-.17-1.09.09-2.19.74-3.08s1.61-1.48 2.7-1.66c1.09-.17 2.19.09 3.08.74.9.65 1.48 1.61 1.66 2.7.17 1.09-.09 2.19-.74 3.08a4.127 4.127 0 0 1-3.36 1.71Zm.01-6.04c-.1 0-.2 0-.3.02-.5.08-.94.35-1.24.76s-.42.91-.34 1.41c.08.5.35.94.76 1.24.41.3.91.42 1.41.34s.94-.35 1.23-.76c.3-.41.42-.91.34-1.41a1.9 1.9 0 0 0-.76-1.24c-.33-.24-.71-.36-1.11-.36ZM42.24 70.65c-.43 0-.86-.07-1.29-.21-2.17-.71-3.37-3.05-2.66-5.22a4.145 4.145 0 0 1 5.22-2.66c2.17.71 3.37 3.05 2.66 5.22a4.095 4.095 0 0 1-2.06 2.41c-.59.3-1.23.45-1.88.45Zm0-6.04c-.8 0-1.54.51-1.8 1.31-.16.48-.12.99.11 1.44s.62.79 1.1.94c.48.16 1 .12 1.44-.11a1.89 1.89 0 0 0-.27-3.48c-.19-.06-.39-.09-.58-.09ZM70 50.47c-2.28 0-4.14-1.86-4.14-4.14s1.86-4.14 4.14-4.14 4.14 1.86 4.14 4.14-1.86 4.14-4.14 4.14Zm0-6.04c-1.04 0-1.89.85-1.89 1.89s.85 1.89 1.89 1.89 1.89-.85 1.89-1.89-.85-1.89-1.89-1.89Z" style="fill:#808689;"></path><path d="M70 92.27c-9.04 0-16.39-7.35-16.39-16.39S60.96 59.49 70 59.49s16.39 7.35 16.39 16.39S79.04 92.27 70 92.27Zm0-30.52c-7.79 0-14.14 6.34-14.14 14.14S62.2 90.03 70 90.03s14.14-6.34 14.14-14.14S77.8 61.75 70 61.75Z" style="fill:#005bac;"></path><path d="M73.17 81.12h-6.34c-1.14 0-2.06-.92-2.06-2.06v-6.34c0-1.14.92-2.06 2.06-2.06h6.34c1.14 0 2.06.92 2.06 2.06v6.34c0 1.14-.92 2.06-2.06 2.06Zm-6.15-2.25h5.96v-5.96h-5.96v5.96Z" style="fill:#808689;"></path><path style="fill:#005bac;" d="M14 126.94h112v2.25H14z"></path><path style="fill:none;" d="M0 0h140v140H0z"></path>', 6);
const _hoisted_8$1 = [
  _hoisted_2$g
];
function render$g(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$g, _hoisted_8$1);
}
const ComplexShapesBlueGraphic = { render: render$g };
const _hoisted_1$f = {
  width: "96",
  height: "96",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$f = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "#808689" },
  d: "M68.88 26.27h2.25v86.11h-2.25z"
}, null, -1);
const _hoisted_3$b = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "#005bac" },
  d: "m70 113.97-13.78-13.78 1.59-1.59L70 110.79 82.19 98.6l1.59 1.59L70 113.97zM14 126.94h112v2.25H14z"
}, null, -1);
const _hoisted_4$b = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none" },
  d: "M0 0h140v140H0z"
}, null, -1);
const _hoisted_5$3 = [
  _hoisted_2$f,
  _hoisted_3$b,
  _hoisted_4$b
];
function render$f(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$f, _hoisted_5$3);
}
const DownloadCenterBlueGraphic = { render: render$f };
const _hoisted_1$e = {
  width: "96",
  height: "96",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$e = /* @__PURE__ */ vue.createStaticVNode('<path d="M87.41 94.77v-1.45h1.76v1.45h-1.76Zm1.76.99v6.39h-1.76v-6.39h1.76Z" style="fill:#005bac;"></path><path d="M105.68 113.94H34.32c-2.27 0-4.12-1.85-4.12-4.12V34.85c0-2.27 1.85-4.12 4.12-4.12h71.36c2.27 0 4.12 1.85 4.12 4.12v74.97c0 2.27-1.85 4.12-4.12 4.12ZM34.32 32.97c-1.03 0-1.88.84-1.88 1.88v74.97c0 1.03.84 1.88 1.88 1.88h71.36c1.03 0 1.88-.84 1.88-1.88V34.85c0-1.03-.84-1.88-1.88-1.88H34.32Z" style="fill:#808689;"></path><path style="fill:#808689;" d="M68.88 26.27h2.25v11.16h-2.25zM49.53 26.27h2.25v11.16h-2.25zM88.22 26.27h2.25v11.16h-2.25zM42.83 51.38h54.34v2.25H42.83zM42.83 63.5h54.34v2.25H42.83zM42.83 75.62h54.34v2.25H42.83zM42.83 87.73H70v2.25H42.83z"></path><path d="M88.29 107.74c-5.52 0-10-4.49-10-10s4.49-10 10-10 10 4.49 10 10-4.49 10-10 10Zm0-17.76c-4.28 0-7.75 3.48-7.75 7.75s3.48 7.75 7.75 7.75 7.75-3.48 7.75-7.75-3.48-7.75-7.75-7.75ZM14 126.94h112v2.25H14z" style="fill:#005bac;"></path><path style="fill:none;" d="M0 0h140v140H0z"></path>', 5);
const _hoisted_7$1 = [
  _hoisted_2$e
];
function render$e(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$e, _hoisted_7$1);
}
const OrderInformationBlueGraphic = { render: render$e };
const _hoisted_1$d = {
  width: "96",
  height: "96",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$d = /* @__PURE__ */ vue.createStaticVNode('<path d="M68.67 56.76H55l13.67-23.64v23.64Zm-9.77-2.25h7.52V41.5L58.9 54.51ZM68.67 116.78H20.29l9.8-16.95h38.58v16.95Zm-44.48-2.25h42.23v-12.45H31.38l-7.2 12.45ZM68.67 96.54H31.99l10.76-18.61h25.92v18.61Zm-32.78-2.25h30.53V80.18H44.05l-8.16 14.11ZM68.67 74.65H44.65l8.45-14.61h15.57v14.61ZM48.55 72.4h17.87V62.29H54.4L48.55 72.4Z" style="fill:#808689;"></path><path style="fill:#005bac;" d="M68.67 33.12 54.99 56.76h2.6l11.08-19.15v-4.49zM30.09 99.83l-9.8 16.95h2.59l9.8-16.95h-2.59zM42.75 77.94l-10.77 18.6h2.6l10.76-18.6h-2.59zM53.09 60.04l-8.45 14.61h2.6l8.45-14.61h-2.6z"></path><path d="M86.8 56.76H73.13V33.12L86.8 56.76Zm-11.42-2.25h7.52L75.38 41.5v13.01ZM121.51 116.78H73.13V99.83h38.58l9.8 16.95Zm-46.13-2.25h42.23l-7.2-12.45H75.38v12.45ZM109.81 96.54H73.13V77.93h25.92l10.76 18.61Zm-34.43-2.25h30.53l-8.16-14.11H75.38v14.11ZM97.15 74.65H73.13V60.04H88.7l8.45 14.61ZM75.38 72.4h17.87L87.4 62.29H75.38V72.4Z" style="fill:#808689;"></path><path style="fill:#005bac;" d="M14 126.94h112v2.25H14z"></path><path style="fill:none;" d="M0 0h140v140H0z"></path>', 5);
const _hoisted_7 = [
  _hoisted_2$d
];
function render$d(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$d, _hoisted_7);
}
const ProductsBlueGraphic = { render: render$d };
const _hoisted_1$c = {
  width: "96",
  height: "96",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$c = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M69.18 100.47 42.66 54.38h16.75V43.51h19.62v10.87h16.75l-26.61 46.09ZM46.55 56.63l22.63 39.33 22.71-39.33H76.78V45.76H61.66v10.87H46.55Z",
  style: { "fill": "#808689" }
}, null, -1);
const _hoisted_3$a = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "#005bac" },
  d: "M95.79 54.38h-2.6l-1.3 2.25-.08.14-23.93 41.45 1.3 2.25 26.61-46.09zM14 126.94h112v2.25H14z"
}, null, -1);
const _hoisted_4$a = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "#808689" },
  d: "M14 120.21h112v2.25H14zM14 113.47h112v2.25H14zM14 106.74h112v2.25H14z"
}, null, -1);
const _hoisted_5$2 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none" },
  d: "M0 0h140v140H0z"
}, null, -1);
const _hoisted_6$1 = [
  _hoisted_2$c,
  _hoisted_3$a,
  _hoisted_4$a,
  _hoisted_5$2
];
function render$c(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$c, _hoisted_6$1);
}
const StiffnessBlueGraphic = { render: render$c };
const _hoisted_1$b = {
  width: "96",
  height: "96",
  id: "Artwork",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$b = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "stroke": "#005bac", "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px" },
  d: "M14 128.06h112"
}, null, -1);
const _hoisted_3$9 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px", "stroke": "#808689" },
  d: "M108.68 64.62V45.28h-9.67v9.67H31.32v58.74h13.89L62.4 96.5l17.19 17.19 6.83-6.84L62.4 82.82l-21.41 21.41V64.62h67.69z"
}, null, -1);
const _hoisted_4$9 = [
  _hoisted_2$b,
  _hoisted_3$9
];
function render$b(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$b, _hoisted_4$9);
}
const PeProfileBGraphic = { render: render$b };
const _hoisted_1$a = {
  width: "96",
  height: "96",
  id: "Artwork",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$a = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "stroke": "#005bac", "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px" },
  d: "M14 128.06h112"
}, null, -1);
const _hoisted_3$8 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M70 45.28c-21.36 0-38.68 17.32-38.68 38.68 0 9.35 3.32 17.93 8.85 24.62 1.53 1.86 3.24 3.57 5.09 5.11l4.98-4.98-.4-.4a28.411 28.411 0 0 1-8.32-20.13c0-15.74 12.76-28.49 28.49-28.49S98.5 72.45 98.5 88.18c0 7.86-3.18 14.97-8.32 20.12l-.4.4 4.98 4.98a39.01 39.01 0 0 0 5.09-5.11 38.512 38.512 0 0 0 8.85-24.62c0-21.36-17.32-38.68-38.68-38.68Z",
  style: { "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px", "stroke": "#808689" }
}, null, -1);
const _hoisted_4$8 = [
  _hoisted_2$a,
  _hoisted_3$8
];
function render$a(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$a, _hoisted_4$8);
}
const PeProfileCGraphic = { render: render$a };
const _hoisted_1$9 = {
  width: "96",
  height: "96",
  id: "Artwork",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$9 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "stroke": "#005bac", "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px" },
  d: "M14 128.06h112"
}, null, -1);
const _hoisted_3$7 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px", "stroke": "#808689" },
  d: "M31.32 75.01v38.68h19.34v-9.67h-9.67V84.68h58.02v19.34h-9.67v9.67h19.34V75.01H31.32z"
}, null, -1);
const _hoisted_4$7 = [
  _hoisted_2$9,
  _hoisted_3$7
];
function render$9(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$9, _hoisted_4$7);
}
const PeProfileDGraphic = { render: render$9 };
const _hoisted_1$8 = {
  width: "96",
  height: "96",
  id: "Artwork",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$8 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "stroke": "#005bac", "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px" },
  d: "M14 128.06h112"
}, null, -1);
const _hoisted_3$6 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px", "stroke": "#808689" },
  d: "M40.99 104.02V45.28h-9.67v68.41h77.36v-9.67H40.99z"
}, null, -1);
const _hoisted_4$6 = [
  _hoisted_2$8,
  _hoisted_3$6
];
function render$8(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$8, _hoisted_4$6);
}
const PeProfileLGraphic = { render: render$8 };
const _hoisted_1$7 = {
  width: "96",
  height: "96",
  id: "Artwork",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$7 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "stroke": "#005bac", "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px" },
  d: "M14 128.06h112"
}, null, -1);
const _hoisted_3$5 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px", "stroke": "#808689" },
  d: "M99.01 75.01v29.01H40.99V75.01h-9.67v38.68h77.36V75.01h-9.67z"
}, null, -1);
const _hoisted_4$5 = [
  _hoisted_2$7,
  _hoisted_3$5
];
function render$7(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$7, _hoisted_4$5);
}
const PeProfileU1Graphic = { render: render$7 };
const _hoisted_1$6 = {
  width: "96",
  height: "96",
  id: "Artwork",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$6 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "stroke": "#005bac", "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px" },
  d: "M14 128.06h112"
}, null, -1);
const _hoisted_3$4 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px", "stroke": "#808689" },
  d: "M99.01 94.35v9.67H40.99V75.01h-9.67v38.68h77.36V94.35h-9.67z"
}, null, -1);
const _hoisted_4$4 = [
  _hoisted_2$6,
  _hoisted_3$4
];
function render$6(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$6, _hoisted_4$4);
}
const PeProfileU2Graphic = { render: render$6 };
const _hoisted_1$5 = {
  width: "96",
  height: "96",
  id: "Artwork",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$5 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "stroke": "#005bac", "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px" },
  d: "M14 128.06h112"
}, null, -1);
const _hoisted_3$3 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px", "stroke": "#808689" },
  d: "m31.32 76.79 21.38 36.9h11.17L48.15 86.46h43.7l-15.72 27.23H87.3l21.38-36.9H31.32z"
}, null, -1);
const _hoisted_4$3 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "stroke": "#005bac", "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px" },
  d: "M14 128.06h112"
}, null, -1);
const _hoisted_5$1 = [
  _hoisted_2$5,
  _hoisted_3$3,
  _hoisted_4$3
];
function render$5(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$5, _hoisted_5$1);
}
const PeProfileVGraphic = { render: render$5 };
const _hoisted_1$4 = {
  width: "96",
  height: "96",
  id: "Artwork",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$4 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px", "stroke": "#808689" },
  d: "M84.51 75.01v-9.67H55.49v9.67H31.32v38.68h9.67V84.68h58.02v29.01h9.67V75.01H84.51z"
}, null, -1);
const _hoisted_3$2 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "stroke": "#005bac", "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px" },
  d: "M14 128.06h112"
}, null, -1);
const _hoisted_4$2 = [
  _hoisted_2$4,
  _hoisted_3$2
];
function render$4(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$4, _hoisted_4$2);
}
const PeProfileWBGraphic = { render: render$4 };
const _hoisted_1$3 = {
  width: "96",
  height: "96",
  id: "Artwork",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$3 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "stroke": "#005bac", "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px" },
  d: "M14 128.06h112"
}, null, -1);
const _hoisted_3$1 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none", "stroke-miterlimit": "10", "stroke-width": "2.25px", "stroke": "#808689" },
  d: "M40.99 79.49V45.28h-9.67v43.88h67.69v24.53h9.67v-34.2H40.99z"
}, null, -1);
const _hoisted_4$1 = [
  _hoisted_2$3,
  _hoisted_3$1
];
function render$3(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$3, _hoisted_4$1);
}
const PeProfileZBGraphic = { render: render$3 };
const _hoisted_1$2 = {
  width: "96",
  height: "96",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$2 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M36.14 102.38c-14.69-18.26-12.06-45.39 5.87-60.49 6.06-5.1 13.38-8.45 21.17-9.68l.35 2.22a41.179 41.179 0 0 0-20.08 9.18c-17 14.31-19.49 40.04-5.56 57.36l-1.75 1.41ZM69.93 118.58c-4.44 0-8.93-.68-13.32-2.1l.69-2.14c17.6 5.7 36.99-1.12 47.14-16.59 10.16-15.47 8.71-35.97-3.52-49.85-.27-.31-.55-.62-.83-.92l1.64-1.54c.3.32.59.64.88.97 12.9 14.64 14.42 36.26 3.71 52.57-8.18 12.46-22.04 19.6-36.4 19.6Z",
  style: { "fill": "#808689" }
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m74.81 28.97 1.43 1.99 25.1-5.13-17.09 28.69h11.74l-52.07 53.82-7.45 8.43h2.42l62.4-64.49H88.2l17.67-29.67-28.15 5.76-2.92.6Z",
  style: { "fill": "#808689" }
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "#005bac" },
  d: "M55.89 66.24h12.26l-24.23 42.1-5.01 8.42h-2.43l27.78-48.27H52.01l22.8-39.52 2.92-.6-21.84 37.87zM14 126.94h112v2.25H14z"
}, null, -1);
const _hoisted_5 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none" },
  d: "M0 0h140v140H0z"
}, null, -1);
const _hoisted_6 = [
  _hoisted_2$2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
];
function render$2(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$2, _hoisted_6);
}
const InnovationBlueGraphic = { render: render$2 };
const _hoisted_1$1 = {
  width: "96",
  height: "96",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$1 = /* @__PURE__ */ vue.createStaticVNode('<path d="M71.02 98.66h-2.65L35.45 41.43h22.2V26.28h24.22v15.15h22.2L71.03 98.66Zm-1.35-2.25h.05l30.44-52.73H79.6V28.53H59.88v15.15H39.32l30.33 52.73Z" style="fill:#808689;"></path><path style="fill:#005bac;" d="M68.37 98.66h2.66l33.04-57.23h-2.66L68.37 98.66z"></path><path d="M69.76 122.71c-19.46 0-38.72-.9-55.69-2.6l.22-2.24c16.9 1.69 36.08 2.59 55.47 2.59s38.57-.89 55.47-2.59l.22 2.24c-16.97 1.7-36.23 2.6-55.69 2.6ZM69.76 109.48c-19.55 0-38.9-3.11-55.95-9.01l.73-2.13c16.82 5.81 35.91 8.88 55.21 8.88s38.4-3.07 55.21-8.88l.73 2.13c-17.05 5.89-36.4 9.01-55.95 9.01Z" style="fill:#808689;"></path><path d="M69.76 116.09c-19.11 0-38.36-1.76-55.65-5.08l.42-2.21c17.16 3.29 36.26 5.04 55.23 5.04s38.21-1.74 55.23-5.04l.43 2.21c-17.16 3.32-36.4 5.08-55.66 5.08Z" style="fill:#808689;"></path><path style="fill:#005bac;" d="M14 126.94h112v2.25H14z"></path><path style="fill:none;" d="M0 0h140v140H0z"></path>', 6);
const _hoisted_8 = [
  _hoisted_2$1
];
function render$1(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$1, _hoisted_8);
}
const LoadBlueGraphic = { render: render$1 };
const _hoisted_1 = {
  width: "96",
  height: "96",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2 = /* @__PURE__ */ vue.createStaticVNode('<path d="M71.46 73.92c-.52 0-.97-.36-1.09-.87l-2.01-8.52 2.19-.52 1.8 7.61 12.23-.58.11 2.25-13.17.62h-.05ZM62.41 89.72c-.44 0-.84-.26-1.03-.66l-7.51-16.69 2.05-.92 7.17 15.94 18.77-2.13.25 2.24-19.59 2.23h-.13ZM46.38 51.12H36.16c-.62 0-1.12-.5-1.12-1.12V39.93h2.25v8.94h9.1v2.25ZM103.03 110.76l-.27-8.94-8.94.28-.07-2.25 10.07-.31c.3-.01.59.1.81.3.22.2.34.49.35.79l.31 10.07-2.25.07Z" style="fill:#808689;"></path><path d="M69.88 118.57c-7.39 0-14.85-1.88-21.59-5.79-18.54-10.75-26.47-33.86-18.45-53.75l2.09.84c-7.61 18.86-.09 40.77 17.49 50.96 17.62 10.22 40.38 5.81 52.92-10.25l1.77 1.38c-8.43 10.8-21.24 16.6-34.23 16.6ZM110.16 91.62l-2.09-.84c7.61-18.86.09-40.77-17.49-50.96C72.96 29.6 50.2 34.01 37.66 50.07l-1.77-1.38C49.12 31.74 73.12 27.1 91.71 37.88c18.54 10.75 26.47 33.86 18.45 53.75Z" style="fill:#808689;"></path><path transform="rotate(-60 67.133 80.282)" style="fill:#808689;" d="M30.87 79.16h72.53v2.25H30.87z"></path><path d="M62.27 102.61h-.19c-6.48-.06-11.88-3.04-14.84-8.19-2.49-4.33-3-8.69-1.52-12.94 2.11-6.05 8.5-11.72 17.1-15.16 10.49-4.19 21.29-19.43 21.4-19.58l1.92-2.73.13 3.33c.05 1.37 1.2 33.58-5.48 44.77-3.88 6.49-10.96 10.5-18.52 10.5Zm1.39-34.19c-8.01 3.2-13.92 8.36-15.81 13.81-1.25 3.61-.8 7.33 1.35 11.08 2.55 4.44 7.25 7.01 12.91 7.06h.17c6.77 0 13.11-3.59 16.58-9.4 5.16-8.63 5.35-31.74 5.24-40.29-3.69 4.71-11.98 14.37-20.43 17.75Z" style="fill:#005bac;"></path><path transform="rotate(-59.85 55.71 100.147)" style="fill:#808689;" d="M42.35 99.02h26.71v2.25H42.35z"></path><path style="fill:#005bac;" d="M14 126.94h112v2.25H14z"></path><path style="fill:none;" d="M0 0h140v140H0z"></path>', 7);
const _hoisted_9 = [
  _hoisted_2
];
function render(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1, _hoisted_9);
}
const SustainabilityBlueGraphic = { render };
const graphics = {
  install: (app, ...options) => {
    app.component("helicopter-graphic", HelicopterGraphic);
    app.component("fan-graphic", FanGraphic);
    app.component("compass-graphic", CompassGraphic);
    app.component("truck-graphic", TruckGraphic);
    app.component("bowl-graphic", BowlGraphic);
    app.component("building-graphic", BuildingGraphic);
    app.component("train-graphic", TrainGraphic);
    app.component("heart-graphic", HeartGraphic);
    app.component("crane-graphic", CraneGraphic);
    app.component("arm-graphic", ArmGraphic);
    app.component("van-graphic", VanGraphic);
    app.component("chip-graphic", ChipGraphic);
    app.component("pin-graphic", PinGraphic);
    app.component("graph-graphic", GraphGraphic);
    app.component("people-graphic", PeopleGraphic);
    app.component("ball-graphic", BallGraphic);
    app.component("car-graphic", CarGraphic);
    app.component("innovation-graphic", InnovationGraphic);
    app.component("sustainability-graphic", SustainabilityGraphic);
    app.component("services-graphic", ServicesGraphic);
    app.component("reuse-graphic", ReuseGraphic);
    app.component("recycle-graphic", RecycleGraphic);
    app.component("products-graphic", ProductsGraphic);
    app.component("reduce-graphic", ReduceGraphic);
    app.component("expertise-collaboration-graphic", ExpertiseCollaborationGraphic);
    app.component("fluid-graphic", FluidGraphic);
    app.component("advanced-graphic", AdvancedGraphic);
    app.component("collaborative-graphic", CollaborativeGraphic);
    app.component("design-graphic", DesignGraphic);
    app.component("high-performance-graphic", HighPerformanceGraphic);
    app.component("rapid-graphic", RapidGraphic);
    app.component("technology-graphic", TechnologyGraphic);
    app.component("complex-part-graphic", ComplexPartGraphic);
    app.component("easily-combine-graphic", EasilyCombineGraphic);
    app.component("contact-dark-graphic", ContactDarkGraphic);
    app.component("contact-light-graphic", ContactLightGraphic);
    app.component("load-dark-graphic", LoadDarkGraphic);
    app.component("load-light-graphic", LoadLightGraphic);
    app.component("usp-class-vi-dark-graphic", UspClassViDarkGraphic);
    app.component("usp-class-vi-light-graphic", UspClassViLightGraphic);
    app.component("mechanical-stress-graphic", MechanicalStressGraphic);
    app.component("moisture-absorption-graphic", MoistureAbsorptionGraphic);
    app.component("thermal-expansion-graphic", ThermalExpansionGraphic);
    app.component("download-center-graphic", DownloadCenterGraphic);
    app.component("mask-graphic", MaskGraphic);
    app.component("order-information-graphic", OrderInformationGraphic);
    app.component("ordering-products-graphic", OrderingProductsGraphic);
    app.component("pricing-lead-times-graphic", PricingLeadTimesGraphic);
    app.component("up-to-date-graphic", UpToDateGraphic);
    app.component("moisture-absorption-dark-graphic", MoistureAbsorptionDarkGraphic);
    app.component("temperature-graphic", TemperatureGraphic);
    app.component("dimensional-stability-graphic", DimensionStabilityGraphic);
    app.component("calculator-graphic", CalculatorGraphic);
    app.component("cast-nylon-products-graphic", CastNylonProductsGraphic);
    app.component("chemical-resistance-graphic", ChemicalResistanceGraphic);
    app.component("feather-graphic", FeatherGraphic);
    app.component("low-friction-graphic", LowFrictionGraphic);
    app.component("plane-graphic", PlaneGraphic);
    app.component("pumps-graphic", PumpsGraphic);
    app.component("release-quality-products-graphic", ReleaseQualityProductsGraphic);
    app.component("wearstrip-profiles-graphic", WearstripProfilesGraphic);
    app.component("lining-solutions-graphic", LiningSolutionsGraphic);
    app.component("complex-shapes-blue-graphic", ComplexShapesBlueGraphic);
    app.component("download-center-blue-graphic", DownloadCenterBlueGraphic);
    app.component("order-information-blue-graphic", OrderInformationBlueGraphic);
    app.component("products-blue-graphic", ProductsBlueGraphic);
    app.component("stiffness-blue-graphic", StiffnessBlueGraphic);
    app.component("pe-profile-b-graphic", PeProfileBGraphic);
    app.component("pe-profile-c-graphic", PeProfileCGraphic);
    app.component("pe-profile-d-graphic", PeProfileDGraphic);
    app.component("pe-profile-l-graphic", PeProfileLGraphic);
    app.component("pe-profile-u-1-graphic", PeProfileU1Graphic);
    app.component("pe-profile-u-2-graphic", PeProfileU2Graphic);
    app.component("pe-profile-v-graphic", PeProfileVGraphic);
    app.component("pe-profile-w-graphic", PeProfileWBGraphic);
    app.component("pe-profile-z-graphic", PeProfileZBGraphic);
    app.component("innovation-blue-graphic", InnovationBlueGraphic);
    app.component("load-blue-graphic", LoadBlueGraphic);
    app.component("sustainability-blue-graphic", SustainabilityBlueGraphic);
  }
};
exports.AdvancedGraphic = AdvancedGraphic;
exports.ArmGraphic = ArmGraphic;
exports.BallGraphic = BallGraphic;
exports.BowlGraphic = BowlGraphic;
exports.BuildingGraphic = BuildingGraphic;
exports.CalculatorGraphic = CalculatorGraphic;
exports.CarGraphic = CarGraphic;
exports.CastNylonProductsGraphic = CastNylonProductsGraphic;
exports.ChemicalResistanceGraphic = ChemicalResistanceGraphic;
exports.ChipGraphic = ChipGraphic;
exports.CollaborativeGraphic = CollaborativeGraphic;
exports.CompassGraphic = CompassGraphic;
exports.ComplexPartGraphic = ComplexPartGraphic;
exports.ComplexShapesBlueGraphic = ComplexShapesBlueGraphic;
exports.ContactDarkGraphic = ContactDarkGraphic;
exports.ContactLightGraphic = ContactLightGraphic;
exports.CraneGraphic = CraneGraphic;
exports.DesignGraphic = DesignGraphic;
exports.DimensionStabilityGraphic = DimensionStabilityGraphic;
exports.DownloadCenterBlueGraphic = DownloadCenterBlueGraphic;
exports.DownloadCenterGraphic = DownloadCenterGraphic;
exports.EasilyCombineGraphic = EasilyCombineGraphic;
exports.ExpertiseCollaborationGraphic = ExpertiseCollaborationGraphic;
exports.FanGraphic = FanGraphic;
exports.FeatherGraphic = FeatherGraphic;
exports.FluidGraphic = FluidGraphic;
exports.GraphGraphic = GraphGraphic;
exports.HeartGraphic = HeartGraphic;
exports.HelicopterGraphic = HelicopterGraphic;
exports.HighPerformanceGraphic = HighPerformanceGraphic;
exports.InnovationBlueGraphic = InnovationBlueGraphic;
exports.InnovationGraphic = InnovationGraphic;
exports.LiningSolutionsGraphic = LiningSolutionsGraphic;
exports.LoadBlueGraphic = LoadBlueGraphic;
exports.LoadDarkGraphic = LoadDarkGraphic;
exports.LoadLightGraphic = LoadLightGraphic;
exports.LowFrictionGraphic = LowFrictionGraphic;
exports.MaskGraphic = MaskGraphic;
exports.MechanicalStressGraphic = MechanicalStressGraphic;
exports.MoistureAbsorptionDarkGraphic = MoistureAbsorptionDarkGraphic;
exports.MoistureAbsorptionGraphic = MoistureAbsorptionGraphic;
exports.OrderInformationBlueGraphic = OrderInformationBlueGraphic;
exports.OrderInformationGraphic = OrderInformationGraphic;
exports.OrderingProductsGraphic = OrderingProductsGraphic;
exports.PeProfileBGraphic = PeProfileBGraphic;
exports.PeProfileCGraphic = PeProfileCGraphic;
exports.PeProfileDGraphic = PeProfileDGraphic;
exports.PeProfileLGraphic = PeProfileLGraphic;
exports.PeProfileU1Graphic = PeProfileU1Graphic;
exports.PeProfileU2Graphic = PeProfileU2Graphic;
exports.PeProfileVGraphic = PeProfileVGraphic;
exports.PeProfileWBGraphic = PeProfileWBGraphic;
exports.PeProfileZBGraphic = PeProfileZBGraphic;
exports.PeopleGraphic = PeopleGraphic;
exports.PinGraphic = PinGraphic;
exports.PlaneGraphic = PlaneGraphic;
exports.PricingLeadTimesGraphic = PricingLeadTimesGraphic;
exports.ProductsBlueGraphic = ProductsBlueGraphic;
exports.ProductsGraphic = ProductsGraphic;
exports.PumpsGraphic = PumpsGraphic;
exports.RapidGraphic = RapidGraphic;
exports.RecycleGraphic = RecycleGraphic;
exports.ReduceGraphic = ReduceGraphic;
exports.ReleaseQualityProductsGraphic = ReleaseQualityProductsGraphic;
exports.ReuseGraphic = ReuseGraphic;
exports.ServicesGraphic = ServicesGraphic;
exports.StiffnessBlueGraphic = StiffnessBlueGraphic;
exports.SustainabilityBlueGraphic = SustainabilityBlueGraphic;
exports.SustainabilityGraphic = SustainabilityGraphic;
exports.TechnologyGraphic = TechnologyGraphic;
exports.TemperatureGraphic = TemperatureGraphic;
exports.ThermalExpansionGraphic = ThermalExpansionGraphic;
exports.TrainGraphic = TrainGraphic;
exports.TruckGraphic = TruckGraphic;
exports.UpToDateGraphic = UpToDateGraphic;
exports.UspClassViDarkGraphic = UspClassViDarkGraphic;
exports.UspClassViLightGraphic = UspClassViLightGraphic;
exports.VanGraphic = VanGraphic;
exports.WearstripProfilesGraphic = WearstripProfilesGraphic;
exports.default = graphics;
